(async () => {
  "use strict";

  const root = document.querySelector("[data-tgb-cyo-builder]");
  if (!root || root.dataset.initialized === "true") return;
  root.dataset.initialized = "true";

  const BUILD_VERSION = "2.27-gift-reference";
  root.dataset.builderVersion = BUILD_VERSION;
  const entryParams = new URLSearchParams(window.location.search);
  const requestedEntryStep = Number(entryParams.get("step") || 0);
  const containerScope = normalizeToken(entryParams.get("container_scope") || "");
  if (containerScope) root.dataset.containerScope = containerScope;
  const builderMode = root.dataset.builderMode || "cyo";
  const isCurated = builderMode === "curated";
  const gatewayProductId = root.dataset.gatewayProductId || "";
  const gatewayVariantId = root.dataset.gatewayVariantId || "";
  const gatewayHandle = root.dataset.gatewayHandle || "";
  const gatewayTitle = root.dataset.gatewayTitle || "this curated gift";
  const gatewayIngredients = Array.from(root.querySelectorAll("[data-gateway-ingredient]"))
    .map((node) => String(node.textContent || "").trim())
    .filter(Boolean);
  const gatewayThemes = String(root.dataset.gatewayThemes || "").split("|").filter(Boolean);
  const gatewayTags = String(root.dataset.gatewayTags || "").split("|").filter(Boolean);
  const addonProfile = root.dataset.addonProfile || "";
  const addonIncludes = new Set(String(root.dataset.addonIncludes || "").split("|").map((value) => value.trim()).filter(Boolean));
  const addonExcludes = new Set(String(root.dataset.addonExcludes || "").split("|").map((value) => value.trim()).filter(Boolean));
  const currency = root.dataset.currency || "USD";
  const money = new Intl.NumberFormat("en-US", { style: "currency", currency });

  const stepPanels = Array.from(root.querySelectorAll("[data-step-panel]"));
  const stepTriggers = Array.from(root.querySelectorAll("[data-step-trigger]"));
  const summaryAction = root.querySelector("[data-summary-action]");
  const summaryPanel = root.querySelector(".tgb-builder__summary");
  const summaryToggle = root.querySelector("[data-summary-toggle]");
  const summaryToggleCount = root.querySelector("[data-summary-toggle-count]");
  const summaryToggleLabel = root.querySelector("[data-summary-toggle-label]");
  const headerGiftButton = root.querySelector("[data-builder-header-gift]");
  const headerGiftCount = root.querySelector("[data-builder-header-count]");
  const summaryItems = root.querySelector("[data-summary-items]");
  const summaryTotal = root.querySelector("[data-summary-total]");
  const summaryCount = root.querySelector("[data-summary-count]");
  const summaryContainer = root.querySelector("[data-summary-container]");
  const summaryContainerImage = root.querySelector("[data-summary-container-image]");
  const summaryContainerTitle = root.querySelector("[data-summary-container-title]");
  const summaryContainerPrice = root.querySelector("[data-summary-container-price]");
  const errorNode = root.querySelector("[data-builder-error]");
  const filterPanel = root.querySelector("[data-filter-panel]");
  const filterToggle = root.querySelector("[data-filter-toggle]");
  const filterBody = root.querySelector("[data-filter-body]");
  const searchInput = root.querySelector("[data-product-search]");
  const emptyState = root.querySelector("[data-empty-state]");
  const resultsTitle = root.querySelector("[data-results-title]");
  const resultsCopy = root.querySelector("[data-results-copy]");
  const resultsCount = root.querySelector("[data-results-count]");
  const activeFilters = root.querySelector("[data-active-filters]");
  const containerSearch = root.querySelector("[data-container-search]");
  const containerCards = Array.from(root.querySelectorAll("[data-container-card]"));
  const containerResultsCount = root.querySelector("[data-container-results-count]");
  const containerEmpty = root.querySelector("[data-container-empty]");
  const containerContinue = root.querySelector("[data-container-continue]");
  const clearContainerFilters = root.querySelector("[data-clear-container-filters]");
  const containerTypeInputs = Array.from(root.querySelectorAll('input[name="cyo_container_type"]'));
  const containerOccasionInputs = Array.from(root.querySelectorAll('input[name="cyo_container_occasion"]'));
  const cardFilterButtons = Array.from(root.querySelectorAll("[data-card-filter-button]"));
  const cardFilterCopy = root.querySelector("[data-card-filter-copy]");
  const cardFilterCount = root.querySelector("[data-card-filter-count]");
  const cardFilterEmpty = root.querySelector("[data-card-filter-empty]");
  const cardMessage = root.querySelector("[data-card-message]");
  const cardSignature = root.querySelector("[data-card-signature]");
  const cardModal = root.querySelector("[data-card-modal]");
  const cardModalSave = root.querySelector("[data-card-modal-save]");
  const cardModalError = root.querySelector("[data-card-modal-error]");
  const magnetModal = root.querySelector("[data-magnet-modal]");
  const magnetModalSave = root.querySelector("[data-magnet-modal-save]");
  const magnetModalError = root.querySelector("[data-magnet-modal-error]");
  const magnetQuestion = root.querySelector("[data-magnet-question]");
  const magnetModalTitle = root.querySelector("[data-magnet-modal-title]");
  const magnetPersonalization = root.querySelector("[data-magnet-personalization]");
  const containerPersonalizationModal = root.querySelector("[data-container-personalization-modal]");
  const containerPersonalizationImage = root.querySelector("[data-container-personalization-image]");
  const containerPersonalizationTitle = root.querySelector("[data-container-personalization-title]");
  const containerPersonalizationHelp = root.querySelector("[data-container-personalization-help]");
  const containerPersonalizationTextField = root.querySelector("[data-container-personalization-text-field]");
  const containerPersonalizationTextQuestion = root.querySelector("[data-container-personalization-text-question]");
  const containerPersonalizationText = root.querySelector("[data-container-personalization-text]");
  const containerPersonalizationFileField = root.querySelector("[data-container-personalization-file-field]");
  const containerPersonalizationFileQuestion = root.querySelector("[data-container-personalization-file-question]");
  const containerPersonalizationFile = root.querySelector("[data-container-personalization-file]");
  const containerPersonalizationFileName = root.querySelector("[data-container-personalization-file-name]");
  const containerPersonalizationError = root.querySelector("[data-container-personalization-error]");
  const containerPersonalizationSave = root.querySelector("[data-container-personalization-save]");
  const quickViewModal = root.querySelector("[data-quick-view-modal]");
  const quickViewImage = root.querySelector("[data-quick-view-image]");
  const quickViewTitle = root.querySelector("[data-quick-view-title]");
  const quickViewPrice = root.querySelector("[data-quick-view-price]");
  const quickViewAvailability = root.querySelector("[data-quick-view-availability]");
  const quickViewDescription = root.querySelector("[data-quick-view-description]");
  const quickViewReadMore = root.querySelector("[data-quick-view-read-more]");
  const quickViewAction = root.querySelector("[data-quick-view-action]");
  const finalReview = root.querySelector("[data-final-review]");
  const finalReviewPanel = root.querySelector("[data-final-review-panel]");
  const finalReviewContent = root.querySelector("[data-final-review-content]");
  const finalReviewError = root.querySelector("[data-final-review-error]");
  const finalReviewTotal = root.querySelector("[data-final-review-total]");
  const finalReviewConfirm = root.querySelector("[data-final-review-confirm]");
  const storageKey = `tgb-${builderMode}-draft-${gatewayProductId || "unknown"}-v10`;
  const legacyStorageKeys = isCurated ? [] : [
    `tgb-cyo-draft-${gatewayProductId || "unknown"}-v8`,
    `tgb-cyo-draft-${gatewayProductId || "unknown"}-v7`,
    `tgb-cyo-draft-${gatewayProductId || "unknown"}-v6`,
    `tgb-cyo-draft-${gatewayProductId || "unknown"}-v5`,
    `tgb-cyo-draft-${gatewayProductId || "unknown"}-v4`,
  ];
  const quantities = new Map();
  const magnetValues = {};
  let step = 2;
  let maxStep = 2;
  let cardFilter = "all";
  let cardSelectionBeforeModal = null;
  let cardSelectionOnPointerDown = null;
  let cardSelectionTimer = null;
  let magnetSelectionBeforeModal = null;
  let magnetSelectionOnPointerDown = null;
  let magnetSelectionTimer = null;
  let committedContainer = null;
  let pendingContainer = null;
  let containerSelectionBeforeModal = null;
  let quickViewInput = null;
  let quickViewTrigger = null;
  let reviewReturnFocus = null;

  const categoryContent = {
    all: ["All Gift Items", "Choose from every active standalone gift item. Nothing is added automatically."],
    bucees: ["Buc-ee's Favorites", "Road-trip legends and Texas-sized favorites from Buc-ee's."],
    snacks: ["Snacks", "Crunchy, salty, sweet, and wonderfully snackable Texas favorites."],
    sweet: ["Sweet Treats", "Cookies, candies, chocolates, and Texas-made treats for their sweet side."],
    savory: ["Savory & Gourmet", "Savory bites, pantry favorites, and gourmet Texas flavors."],
    bbq_spicy: ["BBQ, Sauces & Spicy", "Bold barbecue flavor, fiery sauces, seasonings, and Texas heat."],
    drinks: ["Drinks & Coffee", "Coffee, cocoa, mixers, and sippable favorites made for a Texas toast."],
    bath_body: ["Bath, Body & Fragrance", "Soaps, lotions, body care, and fragrant little luxuries for a Texas-sized unwind."],
    home_kitchen: ["Kitchen & Home", "Useful, giftable finds that bring a little Texas warmth into the home."],
    keepsakes: ["Texas Keepsakes", "Memorable Texas touches they can enjoy long after the treats are gone."],
  };
  const regionContent = {
    all: ["All Regions", "Favorites gathered from makers and traditions across Texas."],
    north_texas: ["North Texas", "Big-city spirit, prairie roots, and favorites from Dallas–Fort Worth and beyond."],
    hill_country: ["Hill Country", "Bluebonnets, small-town charm, and flavors inspired by the Texas Hill Country."],
    central_texas: ["Central Texas", "Austin creativity, barbecue country, and much-loved makers from the heart of Texas."],
    gulf_coast_southeast: ["Gulf Coast & Southeast Texas", "Coastal character and Gulf-inspired favorites from Houston to the shoreline."],
    east_texas: ["East Texas", "Piney Woods hospitality, country comfort, and East Texas favorites."],
    south_texas: ["South Texas", "Borderland flavor, ranch-country character, and favorites from San Antonio southward."],
    west_texas_panhandle: ["West Texas & Panhandle", "Wide-open spirit and bold favorites from Midland to the Panhandle."],
  };
  const cardFilterContent = {
    all: "Browse every card currently available for your gift.",
    christmas: "Christmas and holiday greetings with a little Texas cheer.",
    birthday: "Cheerful designs made to celebrate their big day.",
    thank_you: "Warm Texas ways to show your gratitude and appreciation.",
    thinking_of_you: "A thoughtful hello for care packages, encouragement, or just because.",
    get_well: "Send comfort, encouragement, and a little Texas sunshine.",
    congratulations: "Celebrate achievements, milestones, and graduations in Texas style.",
    love_anniversary: "Cards for love, anniversaries, and heartfelt celebrations.",
    welcome: "Friendly greetings for new homes, new teams, and new beginnings.",
    sympathy: "A gentle, sincere message of comfort and support.",
    general: "Texas-forward designs that work beautifully for almost any occasion.",
  };

  function selectedContainerType() {
    return root.querySelector('input[name="cyo_container_type"]:checked')?.value || "all";
  }

  function selectedContainerOccasion() {
    return root.querySelector('input[name="cyo_container_occasion"]:checked')?.value || "all";
  }

  function containerMatches(card, { type = selectedContainerType(), occasion = selectedContainerOccasion(), query = "" } = {}) {
    const normalizedQuery = normalizeToken(query || containerSearch?.value || "");
    const title = normalizeToken(card.dataset.containerTitle || "");
    const cardType = card.dataset.containerType || "";
    const occasions = String(card.dataset.containerOccasions || "")
      .split("|")
      .filter(Boolean);
    const typeMatch = type === "all" || cardType === type;
    const occasionMatch = occasion === "all" || occasions.includes(occasion);
    const searchMatch = !normalizedQuery || title.includes(normalizedQuery);
    const scopeMatch = containerScope !== "bucees" || title.includes("buc_ee");
    return scopeMatch && typeMatch && occasionMatch && searchMatch;
  }

  function updateContainerFilterCounts() {
    const query = containerSearch?.value || "";
    const activeType = selectedContainerType();
    const activeOccasion = selectedContainerOccasion();

    root.querySelectorAll("[data-container-type-count]").forEach((node) => {
      const value = node.dataset.containerTypeCount || "all";
      const count = containerCards.filter((card) =>
        containerMatches(card, { type: value, occasion: activeOccasion, query }),
      ).length;
      node.textContent = `(${count})`;
    });

    root.querySelectorAll("[data-container-occasion-count]").forEach((node) => {
      const value = node.dataset.containerOccasionCount || "all";
      const count = containerCards.filter((card) =>
        containerMatches(card, { type: activeType, occasion: value, query }),
      ).length;
      node.textContent = `(${count})`;
    });
  }

  function applyContainerFilters({ persist = true } = {}) {
    const visible = containerCards.filter((card) => {
      const matches = containerMatches(card);
      card.hidden = !matches;
      return matches;
    }).length;
    if (containerResultsCount) {
      containerResultsCount.textContent = `${visible} container${visible === 1 ? "" : "s"} shown`;
    }
    if (containerEmpty) containerEmpty.hidden = visible !== 0;
    updateContainerFilterCounts();
    if (clearContainerFilters) {
      const hasFilters =
        selectedContainerType() !== "all" ||
        selectedContainerOccasion() !== "all" ||
        Boolean(containerSearch?.value.trim());
      clearContainerFilters.hidden = !hasFilters;
    }
    if (persist) saveDraft();
  }

  function selectedInputs() {
    return Array.from(root.querySelectorAll("[data-cyo-item]:checked:not(:disabled)"));
  }

  function selectedContainer() {
    return root.querySelector("[data-cyo-container]:checked:not(:disabled)");
  }

  function selectedCard() {
    return root.querySelector('[data-cyo-item][data-role="card"]:checked:not(:disabled)');
  }

  function selectedMagnet() {
    return root.querySelector('[data-cyo-item][data-role="magnet"]:checked:not(:disabled), [data-cyo-item][data-role="scraper"]:checked:not(:disabled)');
  }

  function quantityFor(input) {
    if (!input || input.dataset.role !== "gift") return 1;
    return Math.max(1, Number(quantities.get(String(input.dataset.variantId)) || 1));
  }

  function itemData(input) {
    return {
      variantId: Number(input.dataset.variantId),
      role: input.dataset.role || "gift",
      title: input.dataset.title || "Gift item",
      priceCents: Number(input.dataset.priceCents || 0),
      image: input.dataset.image || "",
      quantity: quantityFor(input),
    };
  }

  function escapeHtml(value) {
    const node = document.createElement("span");
    node.textContent = String(value || "");
    return node.innerHTML;
  }

  function normalizeToken(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_|_$/g, "");
  }

  function categoriesForCard(card) {
    const supplied = String(card.dataset.categories || card.dataset.category || "")
      .split(/[|,]/)
      .map(normalizeToken)
      .filter(Boolean);
    const aliases = {
      bbq: "bbq_spicy",
      spicy: "bbq_spicy",
      bath: "bath_body",
      home: "home_kitchen",
      kitchen: "home_kitchen",
      keepsake: "keepsakes",
    };
    const allowed = new Set(["bucees", "snacks", "sweet", "savory", "bbq_spicy", "drinks", "bath_body", "home_kitchen", "keepsakes"]);
    const explicit = supplied.map((value) => aliases[value] || value).filter((value) => allowed.has(value));
    if (explicit.length) return Array.from(new Set(explicit));

    const source = `${card.dataset.search || ""} ${card.dataset.vendor || ""}`;
    const inferred = new Set();
    if (/\b(soap|lotion|body butter|bath|shower|lip balm|hand cream|skin care|skincare|spa|scrub|salve)\b/.test(source)) inferred.add("bath_body");
    if (/\b(candle|pillow|tea towel|dish towel|kitchen|home decor|cutting board|cheese board|serving board|coaster|apron|spatula|oven mitt|pot holder|mug|tumbler|cup|glassware)\b/.test(source)) inferred.add("home_kitchen");
    if (/\b(souvenir|keepsake|ornament|keychain|sticker|decal|plush|stuffed|bandana|cap|hat|beanie|socks|koozie|can cooler|postcard|notebook|journal|pen|pencil|bookmark|wallet|purse|bottle opener)\b/.test(source)) inferred.add("keepsakes");
    if (/\b(coffee|tea|cocoa|hot chocolate|drink|beverage|cider|lemonade|bloody mary|margarita|cocktail|soda)\b/.test(source)) inferred.add("drinks");
    if (/\b(bbq|barbecue|hot sauce|pepper sauce|salsa|jalape[nñ]o|habanero|ghost pepper|reaper|spicy|chili|seasoning|spice rub|dry rub|grilling|wing sauce|mustard sauce)\b/.test(source)) inferred.add("bbq_spicy");
    if (/\b(candy|chocolate|cookie|brownie|brittle|praline|toffee|caramel|fudge|gummy|gummies|taffy|sweet|dessert|cake|pie|cinnamon|honey|jam|jelly|preserve|pecan butter)\b/.test(source)) inferred.add("sweet");
    if (/\b(jerky|biltong|sausage|cheese|olive|pickle|dip mix|soup|cornbread|cracker|oil|vinegar|savory|gourmet|pasta|bean|chowder)\b/.test(source)) inferred.add("savory");
    if (/\b(snack|popcorn|pretzel|chip|nuts?|pecan|trail mix|party mix|energy bar|protein bar)\b/.test(source)) inferred.add("snacks");
    return Array.from(inferred);
  }

  function regionForCard(card) {
    const supplied = normalizeToken(card.dataset.region);
    const allowed = new Set([
      "north_texas",
      "hill_country",
      "central_texas",
      "gulf_coast_southeast",
      "east_texas",
      "south_texas",
      "west_texas_panhandle",
    ]);
    if (allowed.has(supplied)) return supplied;
    return "";
  }

  function prepareCatalogMetadata() {
    root.querySelectorAll("[data-gift-card]").forEach((card) => {
      card.dataset.categories = categoriesForCard(card).join("|");
      card.dataset.region = regionForCard(card);
    });
  }

  function curatedCardMatches(card) {
    if (!isCurated) return true;
    const handle = String(card.dataset.handle || "").trim();
    if (addonExcludes.has(handle)) return false;
    if (addonIncludes.has(handle)) return true;

    const baseProfile = normalizeToken(addonProfile);
    const cardProfiles = String(card.dataset.addonProfiles || "")
      .split("|")
      .map(normalizeToken)
      .filter(Boolean);
    if (baseProfile && cardProfiles.length) return cardProfiles.includes(baseProfile);

    const categories = new Set(String(card.dataset.categories || "").split("|").filter(Boolean));
    const itemSource = normalizeToken(`${card.dataset.search || ""} ${card.dataset.tags || ""} ${handle}`);
    const giftSource = normalizeToken(`${gatewayTitle} ${gatewayThemes.join(" ")} ${gatewayTags.join(" ")} ${addonProfile}`);

    const hasCategory = (...wanted) => wanted.some((value) => categories.has(value));
    const itemMentions = (...wanted) => wanted.some((value) => itemSource.includes(normalizeToken(value)));
    if (baseProfile === "bbq_scraper" && itemMentions("scraper")) return false;

    if (/buc_?ees?|beaver_nugget/.test(giftSource)) {
      return itemMentions("buc ees", "beaver") || hasCategory("snacks", "sweet");
    }
    if (/bbq|barbecue|pitmaster|grill|smoke|spicy/.test(giftSource)) {
      return hasCategory("bbq_spicy", "savory") || (hasCategory("keepsakes") && itemMentions("bbq", "grill", "scraper", "bottle opener"));
    }
    if (/self_care|spa|bath|relax|serenity/.test(giftSource)) {
      return hasCategory("bath_body") || (hasCategory("home_kitchen") && itemMentions("candle", "mug", "tea"));
    }
    if (/charcuterie|graze|rancher|banquet/.test(giftSource)) {
      return hasCategory("savory", "home_kitchen", "sweet");
    }
    if (/breakfast|jam|preserve|praline|pecan/.test(giftSource)) {
      return hasCategory("sweet", "drinks", "savory");
    }
    if (/sweet_tooth|romantic|valentine|love|treat/.test(giftSource)) {
      return hasCategory("sweet", "snacks") || (hasCategory("keepsakes") && itemMentions("candle", "heart"));
    }
    if (/snack|care_package/.test(giftSource)) {
      return hasCategory("snacks", "sweet", "savory");
    }
    if (/housewarming|welcome|new_home|home_|real_estate|realtor|toast/.test(giftSource)) {
      return hasCategory("home_kitchen", "drinks", "sweet", "savory");
    }
    if (/spring|flower|bluebonnet|garden/.test(giftSource)) {
      return hasCategory("bath_body", "home_kitchen", "sweet");
    }
    if (/gourmet|hill_country|texas_pride/.test(giftSource)) {
      return hasCategory("savory", "sweet", "snacks", "home_kitchen");
    }
    return hasCategory("snacks", "sweet", "savory", "keepsakes");
  }

  function moveUnavailableProductsToEnd() {
    const grid = root.querySelector("[data-product-grid]");
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll("[data-gift-card]"));
    cards
      .sort((a, b) => Number(Boolean(a.querySelector("[data-cyo-item]:disabled"))) - Number(Boolean(b.querySelector("[data-cyo-item]:disabled"))))
      .forEach((card) => grid.appendChild(card));
  }

  function updateFilterAvailability() {
    const cards = Array.from(root.querySelectorAll("[data-gift-card]"));
    root.querySelectorAll('input[name="cyo_category"]').forEach((input) => {
      const label = input.closest("label");
      if (!label || input.value === "all") return;
      label.hidden = !cards.some((card) => String(card.dataset.categories || "").split("|").includes(input.value));
    });
    root.querySelectorAll('input[name="cyo_region"]').forEach((input) => {
      const label = input.closest("label");
      if (!label || input.value === "all") return;
      label.hidden = !cards.some((card) => card.dataset.region === input.value);
    });
  }

  function cardOccasions(choice) {
    return String(choice?.dataset.cardOccasions || "")
      .split("|")
      .map(normalizeToken)
      .filter(Boolean);
  }

  function applyCardFilters({ persist = true } = {}) {
    const choices = Array.from(root.querySelectorAll("[data-card-choice]"));
    let visible = 0;
    choices.forEach((choice) => {
      const input = choice.querySelector('input[name="cyo_card"]');
      const matches = cardFilter === "all" || cardOccasions(choice).includes(cardFilter);
      choice.hidden = !(matches || input?.checked);
      if (matches) visible += 1;
    });

    const noCard = root.querySelector("[data-card-no-card]");
    if (noCard) noCard.hidden = false;
    if (cardFilterCopy) cardFilterCopy.textContent = cardFilterContent[cardFilter] || cardFilterContent.all;
    if (cardFilterCount) cardFilterCount.textContent = `${visible} design${visible === 1 ? "" : "s"}`;
    if (cardFilterEmpty) cardFilterEmpty.hidden = visible > 0;

    cardFilterButtons.forEach((button) => {
      const value = button.dataset.cardFilterButton || "all";
      const count = value === "all" ? choices.length : choices.filter((choice) => cardOccasions(choice).includes(value)).length;
      button.hidden = value !== "all" && count === 0;
      button.classList.toggle("is-active", value === cardFilter);
      button.setAttribute("aria-pressed", String(value === cardFilter));
      const countNode = button.querySelector("[data-card-filter-button-count]");
      if (countNode) countNode.textContent = String(count);
    });

    if (persist) saveDraft();
  }

  async function loadRemainingGiftPages() {
    const currentUrl = new URL(window.location.href);
    if (Number(currentUrl.searchParams.get("page") || 1) !== 1) return;
    const grid = root.querySelector("[data-product-grid]");
    if (!grid) return;

    for (let pageNumber = 2; pageNumber <= 8; pageNumber += 1) {
      const url = new URL(currentUrl);
      url.searchParams.set("page", String(pageNumber));
      const response = await fetch(url.toString(), { credentials: "same-origin" });
      if (!response.ok) break;
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const cards = Array.from(parsed.querySelectorAll("[data-product-grid] [data-gift-card]"));
      if (!cards.length) break;
      cards.forEach((card) => grid.appendChild(document.importNode(card, true)));
      if (cards.length < 250) break;
    }
  }

  function updateChoiceState(name) {
    root.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
      const choice = input.closest(".tgb-choice-card");
      if (!choice) return;
      choice.classList.toggle("is-selected", input.checked);
      const action = choice.querySelector(".tgb-choice-card__action");
      if (action) action.textContent = input.checked ? "Selected" : "Select";
    });
  }

  function clearCardDraft() {
    cardMessage.value = "";
    cardSignature.value = "";
    cardMessage.removeAttribute("aria-invalid");
    cardModalError.hidden = true;
  }

  function updateCardState() {
    updateChoiceState("cyo_card");
    if (selectedCard()) {
      cardMessage.removeAttribute("aria-invalid");
    } else {
      clearCardDraft();
    }
  }

  function updateMagnetState() {
    updateChoiceState("cyo_magnet");
    const magnet = selectedMagnet();
    if (!magnet) {
      magnetPersonalization.removeAttribute("aria-invalid");
      magnetPersonalization.value = "";
      return;
    }
    const variantId = String(magnet.dataset.variantId || "");
    magnetQuestion.textContent = magnet.dataset.personalizationQuestion || "What would you like engraved?";
    magnetPersonalization.value = magnetValues[variantId] || "";
    magnetPersonalization.dataset.propertyName = magnet.dataset.personalizationProperty || "Engraving";
  }

  function updateRibbonCharacterCounts() {
    const left = root.querySelector("[data-ribbon-left]");
    const right = root.querySelector("[data-ribbon-right]");
    const leftCount = root.querySelector("[data-ribbon-left-count]");
    const rightCount = root.querySelector("[data-ribbon-right-count]");
    if (leftCount) leftCount.textContent = String(left?.value.length || 0);
    if (rightCount) rightCount.textContent = String(right?.value.length || 0);
  }

  function updateDependentFields(input, { focus = false } = {}) {
    const controls = input.dataset.controls;
    if (!controls) return;
    const panel = root.querySelector(`#${CSS.escape(controls)}`);
    if (!panel) return;
    panel.hidden = !input.checked;
    input.setAttribute("aria-expanded", String(input.checked));
    if (!input.checked) {
      panel.querySelectorAll("input, textarea").forEach((field) => field.removeAttribute("aria-invalid"));
    } else if (focus && input.dataset.role === "ribbon") {
      window.requestAnimationFrame(() => panel.querySelector("[data-ribbon-left]")?.focus());
    }
  }

  function updateProductCard(input) {
    const card = input.closest("[data-product-card]");
    if (!card) return;
    card.classList.toggle("is-selected", input.checked);
    const action = card.querySelector(".tgb-product-card__action");
    if (!action) return;
    action.classList.remove("has-quantity");
    if (input.disabled) {
      action.textContent = "Out of stock";
      return;
    }
    if (input.matches("[data-cyo-container]")) {
      action.textContent = input.checked ? "Selected" : "Choose";
      return;
    }
    if (input.dataset.role === "gift" && input.checked) {
      action.classList.add("has-quantity");
      action.innerHTML = `<span class="tgb-product-card__quantity" aria-label="Quantity for ${escapeHtml(input.dataset.title || "gift item")}">
        <button type="button" data-card-quantity="-1" data-variant-id="${escapeHtml(input.dataset.variantId)}" aria-label="Decrease quantity">−</button>
        <strong aria-live="polite">${quantityFor(input)}</strong>
        <button type="button" data-card-quantity="1" data-variant-id="${escapeHtml(input.dataset.variantId)}" aria-label="Increase quantity">+</button>
      </span>`;
      return;
    }
    if (input.dataset.role === "ribbon") {
      action.textContent = input.checked ? "Added to your gift" : "+ Add finishing touch";
      return;
    }
    action.textContent = input.checked ? "Added" : "+ Add";
  }

  function normalizeQuantity(input) {
    const key = String(input.dataset.variantId);
    if (input.checked && input.dataset.role === "gift" && !quantities.has(key)) quantities.set(key, 1);
    if (!input.checked) quantities.delete(key);
  }

  function totalCents() {
    const container = selectedContainer();
    const containerPriceCents = Number(container?.dataset.priceCents || 0);
    return selectedInputs().reduce(
      (total, input) => total + Number(input.dataset.priceCents || 0) * quantityFor(input),
      containerPriceCents,
    );
  }

  function summaryMarkup(input) {
    const item = itemData(input);
    const roleLabel =
      {
        gift: "Gift item",
        card: "Card",
        keepsake: "City keepsake",
        magnet: "Personalized magnet",
        scraper: "Customized BBQ scraper",
        ribbon: "Finishing touch",
      }[item.role] || "Personal touch";
    const quantityLabel = item.quantity > 1 ? ` · Qty ${item.quantity}` : "";
    const price = money.format((item.priceCents * item.quantity) / 100);
    const controls =
      item.role === "gift"
        ? `<span class="tgb-summary-item__quantity" aria-label="Quantity for ${escapeHtml(item.title)}">
            <button type="button" data-card-quantity="-1" data-variant-id="${item.variantId}" aria-label="Decrease quantity">−</button>
            <strong aria-live="polite">${item.quantity}</strong>
            <button type="button" data-card-quantity="1" data-variant-id="${item.variantId}" aria-label="Increase quantity">+</button>
          </span>`
        : "";
    return `<article class="tgb-summary-item">
      <img src="${escapeHtml(item.image)}" alt="">
      <div><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(roleLabel + quantityLabel)}</small></div>
      <span class="tgb-summary-item__price">${escapeHtml(price)}</span>
      <div class="tgb-summary-item__actions">
        ${controls}
        <button type="button" class="tgb-summary-item__remove" data-summary-remove="${item.variantId}" data-summary-role="${escapeHtml(item.role)}">Remove</button>
      </div>
    </article>`;
  }

  function updateSummary() {
    const container = selectedContainer();
    const selected = selectedInputs();
    summaryContainer.hidden = !container;
    if (container) {
      summaryContainerImage.src = container.dataset.image || "";
      summaryContainerImage.alt = container.dataset.title || "Selected container";
      summaryContainerTitle.textContent = container.dataset.title || "Selected container";
      summaryContainerPrice.textContent = money.format(Number(container.dataset.priceCents || 0) / 100);
    }
    summaryItems.innerHTML = selected.length
      ? selected.map(summaryMarkup).join("")
      : `<p class="tgb-summary-empty">${isCurated ? "Add something extra to see it here. Your curated gift is already complete." : "Add gift items to see them here."}</p>`;
    summaryTotal.textContent = money.format(totalCents() / 100);
    const itemCount = (container ? 1 : 0) + selected.reduce((count, input) => count + quantityFor(input), 0);
    summaryCount.textContent = `${itemCount} item${itemCount === 1 ? "" : "s"}`;
    if (summaryToggleCount) summaryToggleCount.textContent = String(itemCount);
    if (headerGiftCount) headerGiftCount.textContent = String(itemCount);
    if (!summaryAction.disabled) summaryAction.textContent = stepLabel(step);
  }

  function setSummaryExpanded(expanded) {
    if (!summaryPanel || !summaryToggle) return;
    summaryPanel.classList.toggle("is-expanded", Boolean(expanded));
    summaryToggle.setAttribute("aria-expanded", String(Boolean(expanded)));
    if (summaryToggleLabel) summaryToggleLabel.textContent = expanded ? "Close" : "Open";
  }

  function saveDraft() {
    try {
      const state = {
        schemaVersion: 9,
        containerVariantId: String(selectedContainer()?.dataset.variantId || gatewayVariantId),
        checked: selectedInputs().map((input) => String(input.dataset.variantId)),
        quantities: Object.fromEntries(quantities),
        cardMessage: selectedCard() ? cardMessage.value : "",
        cardSignature: selectedCard() ? cardSignature.value : "",
        magnetValues,
        ribbonLeft: root.querySelector("[data-ribbon-left]")?.value || "",
        ribbonRight: root.querySelector("[data-ribbon-right]")?.value || "",
        step,
        maxStep,
        category: root.querySelector('input[name="cyo_category"]:checked')?.value || "all",
        region: root.querySelector('input[name="cyo_region"]:checked')?.value || "all",
        search: searchInput?.value || "",
        cardFilter,
        filtersExpanded: filterToggle.getAttribute("aria-expanded") === "true",
        containerType: selectedContainerType(),
        containerOccasion: selectedContainerOccasion(),
        containerSearch: containerSearch?.value || "",
      };
      window.sessionStorage.setItem(storageKey, JSON.stringify(state));
    } catch {}
  }

  function restoreDraft() {
    try {
      let sourceKey = storageKey;
      let raw = window.sessionStorage.getItem(storageKey);
      if (!raw) {
        sourceKey = legacyStorageKeys.find((key) => window.sessionStorage.getItem(key)) || storageKey;
        raw = window.sessionStorage.getItem(sourceKey);
      }
      const state = JSON.parse(raw || "null");
      if (!state || !Array.isArray(state.checked)) return { legacyKey: null, step: 2, maxStep: 2 };
      if (entryParams.get('builder_entry_source') === 'container_product_page' &&
          String(state.containerVariantId || '') !== String(gatewayVariantId)) {
        window.sessionStorage.setItem(`${storageKey}-container-${state.containerVariantId || 'unknown'}`, raw);
        return { legacyKey: null, step: 2, maxStep: 2 };
      }
      root.querySelectorAll("[data-cyo-item]").forEach((input) => {
        input.checked = state.checked.includes(String(input.dataset.variantId));
      });
      if (state.containerVariantId) {
        const restoredContainer = root.querySelector(
          `[data-cyo-container][data-variant-id="${CSS.escape(String(state.containerVariantId))}"]`,
        );
        if (restoredContainer && !restoredContainer.disabled) restoredContainer.checked = true;
      }
      if (state.quantities && typeof state.quantities === "object") {
        Object.entries(state.quantities).forEach(([variantId, quantity]) => {
          const parsed = Number(quantity);
          if (Number.isInteger(parsed) && parsed > 0) quantities.set(String(variantId), parsed);
        });
      }
      if (selectedCard()) {
        cardMessage.value = state.cardMessage || "";
        cardSignature.value = state.cardSignature || "";
      } else {
        clearCardDraft();
      }
      Object.assign(magnetValues, state.magnetValues || {});
      if (state.magnetName && selectedMagnet()) magnetValues[String(selectedMagnet().dataset.variantId)] = state.magnetName;
      [
        ["[data-ribbon-left]", state.ribbonLeft],
        ["[data-ribbon-right]", state.ribbonRight],
      ].forEach(([selector, value]) => {
        const field = root.querySelector(selector);
        if (field) field.value = value || "";
      });
      const categoryInput = root.querySelector(`input[name="cyo_category"][value="${CSS.escape(state.category || "all")}"]`);
      const regionInput = root.querySelector(`input[name="cyo_region"][value="${CSS.escape(state.region || "all")}"]`);
      if (categoryInput) categoryInput.checked = true;
      if (regionInput) regionInput.checked = true;
      if (searchInput) searchInput.value = state.search || "";
      if (cardFilterContent[state.cardFilter]) cardFilter = state.cardFilter;
      if (typeof state.filtersExpanded === "boolean") {
        filterToggle.setAttribute("aria-expanded", String(state.filtersExpanded));
        filterBody.hidden = !state.filtersExpanded;
      }
      const containerTypeInput = root.querySelector(
        `input[name="cyo_container_type"][value="${CSS.escape(state.containerType || "all")}"]`,
      );
      const containerOccasionInput = root.querySelector(
        `input[name="cyo_container_occasion"][value="${CSS.escape(state.containerOccasion || "all")}"]`,
      );
      if (containerTypeInput) containerTypeInput.checked = true;
      if (containerOccasionInput) containerOccasionInput.checked = true;
      if (containerSearch) containerSearch.value = state.containerSearch || "";
      return {
        legacyKey: sourceKey === storageKey ? null : sourceKey,
        step: Math.max(1, Math.min(5, Number(state.step || 2))),
        maxStep: Math.max(2, Math.min(5, Number(state.maxStep || state.step || 2))),
      };
    } catch {}
    return { legacyKey: null, step: 2, maxStep: 2 };
  }

  function dispatchStepCompleted(completedStep) {
    window.dispatchEvent(new CustomEvent("tgb:builder-step-completed", {
      detail: {
        builderMode,
        stepNumber: Number(completedStep)
      }
    }));
  }

  function stepLabel(currentStep) {
    if (currentStep === 1) return "Continue to Gifts";
    if (currentStep === 2) return "Continue to Card & Message";
    if (currentStep === 3) return `Continue to ${root.dataset.stepFourLabel || "Custom Keepsake"}`;
    if (currentStep === 4) return "Continue to Finishing Touch";
    return `Review Your Gift · ${money.format(totalCents() / 100)}`;
  }

  function showStep(nextStep, { scroll = true, persist = true } = {}) {
    if (isCurated && Number(nextStep) === 1) nextStep = 2;
    step = Math.max(1, Math.min(5, Number(nextStep)));
    maxStep = Math.max(maxStep, step);
    stepPanels.forEach((panel) => {
      panel.hidden = Number(panel.dataset.stepPanel) !== step;
    });
    stepTriggers.forEach((trigger) => {
      const triggerStep = Number(trigger.dataset.stepTrigger);
      trigger.disabled = triggerStep > maxStep || (isCurated && triggerStep === 1);
      trigger.classList.toggle("is-active", triggerStep === step);
      trigger.classList.toggle("is-complete", triggerStep < step);
      const marker = trigger.querySelector("span");
      if (marker) marker.textContent = triggerStep < step ? "✓" : String(triggerStep);
      if (triggerStep === step) trigger.setAttribute("aria-current", "step");
      else trigger.removeAttribute("aria-current");
    });
    filterPanel.hidden = step !== 2;
    summaryAction.textContent = stepLabel(step);
    errorNode.hidden = true;
    setSummaryExpanded(false);
    if (persist) saveDraft();
    if (scroll) {
      root.scrollIntoView({ behavior: "smooth", block: "start" });
      window.setTimeout(() => {
        const activePanel = root.querySelector(`[data-step-panel="${step}"]`);
        const heading = activePanel?.querySelector("h2, h3");
        if (heading) {
          heading.setAttribute("tabindex", "-1");
          heading.focus({ preventScroll: true });
        }
      }, 280);
    }
  }

  function focusMissingField(field) {
    if (!field) return;
    field.setAttribute("aria-invalid", "true");
    field.scrollIntoView({ behavior: "smooth", block: "center" });
    window.setTimeout(() => field.focus({ preventScroll: true }), 260);
  }

  function validateStep(currentStep) {
    errorNode.hidden = true;
    if (!selectedContainer()) {
      errorNode.textContent = "This gift could not load its selected container. Return to the product page and try again.";
      errorNode.hidden = false;
      return false;
    }
    if (!isCurated && currentStep === 2 && !root.querySelector('[data-cyo-item][data-role="gift"]:checked:not(:disabled)')) {
      errorNode.textContent = "Choose at least one gift item before continuing.";
      errorNode.hidden = false;
      root.querySelector('[data-cyo-item][data-role="gift"]:not(:disabled)')?.closest("[data-product-card]")?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return false;
    }
    if (currentStep === 3) {
      if (selectedCard() && !cardMessage.value.trim()) {
        errorNode.textContent = "Please enter the card message or choose “No card.”";
        errorNode.hidden = false;
        openCardModal(selectedCard(), selectedCard());
        return false;
      }
    }
    if (currentStep === 4) {
      const magnet = selectedMagnet();
      if (magnet && !magnetPersonalization.value.trim()) {
        errorNode.textContent = magnet.dataset.personalizationQuestion || "Please enter the engraving.";
        errorNode.hidden = false;
        openMagnetModal(magnet, magnet);
        return false;
      }
    }
    if (currentStep === 5) {
      const ribbon = root.querySelector('[data-cyo-item][data-role="ribbon"]:checked');
      const ribbonLeft = root.querySelector("[data-ribbon-left]");
      const ribbonRight = root.querySelector("[data-ribbon-right]");
      if (ribbon && !ribbonLeft.value.trim() && !ribbonRight.value.trim()) {
        errorNode.textContent = "Enter at least one ribbon message.";
        errorNode.hidden = false;
        ribbonLeft.setAttribute("aria-invalid", "true");
        ribbonRight.setAttribute("aria-invalid", "true");
        focusMissingField(ribbonLeft);
        return false;
      }
    }
    return true;
  }

  function updateFilterPresentation(category, region, term, visible) {
    if (isCurated) {
      resultsTitle.textContent = "Add Something Extra";
      resultsCopy.textContent = `${visible} optional add-on${visible === 1 ? "" : "s"} selected to complement ${gatewayTitle}.${term ? ` Showing matches for “${term}.”` : ""}`;
      resultsCount.textContent = `${visible} add-on${visible === 1 ? "" : "s"}`;

    }
    const categoryInfo = categoryContent[category] || categoryContent.all;
    const regionInfo = regionContent[region] || regionContent.all;
    let title = categoryInfo[0];
    let copy = categoryInfo[1];
    if (category === "all" && region !== "all") {
      title = `${regionInfo[0]} Favorites`;
      copy = regionInfo[1];
    } else if (category !== "all" && region !== "all") {
      title = `${regionInfo[0]} ${categoryInfo[0]}`;
      copy = `${categoryInfo[1]} ${regionInfo[1]}`;
    }
    if (term) copy = `${copy} Showing matches for “${term}.”`;
    if (!isCurated) {
      resultsTitle.textContent = title;
      resultsCopy.textContent = copy;
      resultsCount.textContent = `${visible} gift${visible === 1 ? "" : "s"}`;
    }

    const filterCount = Number(category !== "all") + Number(region !== "all");
    const countLabel = root.querySelector("[data-filter-count]");
    if (countLabel) { countLabel.textContent = `(${filterCount})`; countLabel.hidden = filterCount === 0; }
    const chips = [];
    if (category !== "all") chips.push(`<button type="button" data-clear-filter="category">${escapeHtml(categoryInfo[0])}<span aria-hidden="true">×</span></button>`);
    if (region !== "all") chips.push(`<button type="button" data-clear-filter="region">${escapeHtml(regionInfo[0])}<span aria-hidden="true">×</span></button>`);
    if (term) chips.push(`<button type="button" data-clear-filter="search">“${escapeHtml(term)}”<span aria-hidden="true">×</span></button>`);
    if (chips.length) chips.push('<button type="button" class="tgb-active-filters__clear" data-clear-filter="all">Clear all</button>');
    activeFilters.innerHTML = chips.join("");
    activeFilters.hidden = chips.length === 0;
  }

  function applyFilters({ persist = true } = {}) {
    const category = root.querySelector('input[name="cyo_category"]:checked')?.value || "all";
    const region = root.querySelector('input[name="cyo_region"]:checked')?.value || "all";
    const term = (searchInput.value || "").trim().toLowerCase();
    let visible = 0;
    root.querySelectorAll("[data-gift-card]").forEach((card) => {
      const categories = String(card.dataset.categories || "").split("|").filter(Boolean);
      const matchesCategory = category === "all" || categories.includes(category);
      const matchesRegion = region === "all" || card.dataset.region === region;
      const matchesSearch = !term || (card.dataset.search || "").includes(term);
      const matchesCuratedGift = curatedCardMatches(card);
      card.hidden = !(matchesCategory && matchesRegion && matchesSearch && matchesCuratedGift);
      if (!card.hidden) visible += 1;
    });
    emptyState.hidden = visible > 0;
    updateFilterPresentation(category, region, term, visible);
    if (persist) saveDraft();
  }

  function syncModalState() {
    const hasOpenModal = [containerPersonalizationModal, quickViewModal, cardModal, magnetModal, finalReview].some(
      (modal) => modal && !modal.hidden,
    );
    document.body.classList.toggle("tgb-modal-open", hasOpenModal);
  }

  function renderQuickViewAction() {
    if (!quickViewInput || !quickViewAction) return;
    if (quickViewInput.disabled) {
      quickViewAction.innerHTML = '<button type="button" class="tgb-primary-button" disabled>Out of stock</button>';
      return;
    }
    if (!quickViewInput.checked) {
      quickViewAction.innerHTML = '<button type="button" class="tgb-primary-button" data-quick-view-add>+ Add to Your Gift</button>';
      return;
    }
    quickViewAction.innerHTML = `<span class="tgb-product-card__quantity tgb-quick-view__quantity" aria-label="Quantity for ${escapeHtml(quickViewInput.dataset.title || "gift item")}">
      <button type="button" data-card-quantity="-1" data-variant-id="${escapeHtml(quickViewInput.dataset.variantId)}" aria-label="Decrease quantity">−</button>
      <strong aria-live="polite">${quantityFor(quickViewInput)}</strong>
      <button type="button" data-card-quantity="1" data-variant-id="${escapeHtml(quickViewInput.dataset.variantId)}" aria-label="Increase quantity">+</button>
    </span>`;
  }

  function openQuickView(card, trigger) {
    const input = card?.querySelector('[data-cyo-item][data-role="gift"]');
    if (!input || !quickViewModal) return;
    quickViewInput = input;
    quickViewTrigger = trigger || null;
    const cardImage = card.querySelector(".tgb-product-card__image img");
    quickViewImage.src = cardImage?.currentSrc || cardImage?.src || input.dataset.image || "";
    quickViewImage.alt = input.dataset.title || "Gift item";
    quickViewTitle.textContent = input.dataset.title || "Gift item";
    quickViewPrice.textContent = money.format(Number(input.dataset.priceCents || 0) / 100);
    quickViewAvailability.textContent = input.disabled ? "Out of stock" : "Available to add";
    quickViewAvailability.classList.toggle("is-unavailable", input.disabled);
    quickViewDescription.replaceChildren();
    const template = card.querySelector("[data-product-description]");
    if (template?.content) {
      const fragment = template.content.cloneNode(true);
      fragment.querySelectorAll?.("script, style, iframe, object, form").forEach((node) => node.remove());
      quickViewDescription.appendChild(fragment);
    }
    quickViewDescription.classList.remove("is-expanded");
    quickViewReadMore.textContent = "Read more";
    quickViewReadMore.hidden = true;
    renderQuickViewAction();
    quickViewModal.hidden = false;
    syncModalState();
    window.requestAnimationFrame(() => {
      quickViewReadMore.hidden = quickViewDescription.scrollHeight <= quickViewDescription.clientHeight + 4;
      quickViewModal.querySelector("[data-quick-view-close]")?.focus();
    });
  }

  function closeQuickView() {
    if (!quickViewModal || quickViewModal.hidden) return;
    quickViewModal.hidden = true;
    quickViewInput = null;
    syncModalState();
    quickViewTrigger?.focus?.();
    quickViewTrigger = null;
  }

  function openCardModal(card, previousCard) {
    if (!card || !cardModal) return;
    cardSelectionBeforeModal = previousCard || root.querySelector('input[name="cyo_card"][value="none"]');
    card.checked = true;
    updateCardState();
    updateSummary();
    cardModalError.hidden = true;
    cardModal.hidden = false;
    syncModalState();
    window.requestAnimationFrame(() => cardMessage.focus());
  }

  function closeCardModal({ cancel = true } = {}) {
    if (!cardModal || cardModal.hidden) return;
    if (cancel && cardSelectionBeforeModal) {
      cardSelectionBeforeModal.checked = true;
      updateCardState();
      updateSummary();
    }
    cardModal.hidden = true;
    syncModalState();
    cardSelectionBeforeModal = null;
    saveDraft();
  }

  function saveCardModal() {
    if (!cardMessage.value.trim()) {
      cardModalError.textContent = "Please enter the card message.";
      cardModalError.hidden = false;
      cardMessage.setAttribute("aria-invalid", "true");
      cardMessage.focus();
      return;
    }
    cardMessage.removeAttribute("aria-invalid");
    cardModalError.hidden = true;
    closeCardModal({ cancel: false });
    updateSummary();
    if (step === 3) showStep(4);
  }

  function openMagnetModal(magnet, previousMagnet) {
    if (!magnet || !magnetModal) return;
    if (magnetModalTitle) magnetModalTitle.textContent = magnet.dataset.role === "scraper" ? "Personalize your BBQ scraper" : "Personalize your magnet";
    magnetSelectionBeforeModal = previousMagnet || root.querySelector('input[name="cyo_magnet"][value="none"]');
    magnet.checked = true;
    updateMagnetState();
    updateSummary();
    magnetModalError.hidden = true;
    magnetModal.hidden = false;
    syncModalState();
    window.requestAnimationFrame(() => magnetPersonalization.focus());
  }

  function closeMagnetModal({ cancel = true } = {}) {
    if (!magnetModal || magnetModal.hidden) return;
    if (cancel && magnetSelectionBeforeModal) {
      magnetSelectionBeforeModal.checked = true;
      updateMagnetState();
      updateSummary();
    }
    magnetModal.hidden = true;
    syncModalState();
    magnetSelectionBeforeModal = null;
    saveDraft();
  }

  function saveMagnetModal() {
    const magnet = selectedMagnet();
    if (!magnetPersonalization.value.trim()) {
      magnetModalError.textContent = magnet?.dataset.personalizationQuestion || "Please enter the engraving.";
      magnetModalError.hidden = false;
      magnetPersonalization.setAttribute("aria-invalid", "true");
      magnetPersonalization.focus();
      return;
    }
    if (magnet) magnetValues[String(magnet.dataset.variantId)] = magnetPersonalization.value.trim();
    magnetPersonalization.removeAttribute("aria-invalid");
    magnetModalError.hidden = true;
    closeMagnetModal({ cancel: false });
    updateSummary();
    if (step === 4) showStep(5);
  }

  function formatReviewText(value) {
    return escapeHtml(String(value || "")).replace(/\n/g, "<br>");
  }

  function reviewImageMarkup(item) {
    if (item.image) {
      return `<img class="tgb-final-review__image" src="${escapeHtml(item.image)}" alt="" width="58" height="58">`;
    }
    return '<span class="tgb-final-review__image-missing" aria-hidden="true">Image<br>coming soon</span>';
  }

  function reviewItemMarkup(input, { quantityControls = false, detail = "" } = {}) {
    const item = itemData(input);
    const lineTotal = item.priceCents * item.quantity;
    const price = money.format(lineTotal / 100);
    const quantity = quantityControls
      ? `<span class="tgb-final-review__quantity" aria-label="Quantity for ${escapeHtml(item.title)}">
          <button type="button" data-final-review-quantity="-1" data-variant-id="${escapeHtml(item.variantId)}" aria-label="Decrease ${escapeHtml(item.title)} quantity">−</button>
          <span aria-live="polite">${item.quantity}</span>
          <button type="button" data-final-review-quantity="1" data-variant-id="${escapeHtml(item.variantId)}" aria-label="Increase ${escapeHtml(item.title)} quantity">+</button>
        </span>`
      : "";
    return `<article class="tgb-final-review__item${quantityControls ? " tgb-final-review__gift-row" : ""}">
      ${reviewImageMarkup(item)}
      <div class="tgb-final-review__item-copy">
        <strong>${escapeHtml(item.title)}</strong>
        ${detail ? `<small>${escapeHtml(detail)}</small>` : ""}
      </div>
      ${quantity}
      <span class="tgb-final-review__price">${price}</span>
    </article>`;
  }

  function reviewGroupMarkup(title, editStep, content) {
    const editButton = editStep
      ? `<button type="button" class="tgb-final-review__edit" data-final-review-edit="${editStep}">Edit</button>`
      : "";
    return `<section class="tgb-final-review__group">
      <div class="tgb-final-review__group-head">
        <h3>${escapeHtml(title)}</h3>
        ${editButton}
      </div>
      ${content}
    </section>`;
  }

  function reviewDetailsMarkup(rows) {
    const validRows = rows.filter((row) => String(row.value || "").trim());
    if (!validRows.length) return "";
    return `<dl class="tgb-final-review__details">${validRows
      .map((row) => `<div><dt>${escapeHtml(row.label)}</dt><dd>${formatReviewText(row.value)}</dd></div>`)
      .join("")}</dl>`;
  }

  function renderFinalReview() {
    if (!finalReview || !finalReviewContent) return;
    const container = selectedContainer();
    const allSelected = selectedInputs();
    const gifts = allSelected.filter((input) => input.dataset.role === "gift");
    const card = selectedCard();
    const cityKeepsake = allSelected.find((input) => input.dataset.role === "keepsake") || null;
    const magnet = selectedMagnet();
    const ribbon = allSelected.find((input) => input.dataset.role === "ribbon") || null;
    const customization = readCustomizationMetadata();

    const containerItem = container
      ? {
          image: container.dataset.image || "",
          title: container.dataset.title || "Selected container",
          price: money.format(Number(container.dataset.priceCents || 0) / 100),
        }
      : null;
    const containerMarkup = containerItem
      ? `<article class="tgb-final-review__item">
          ${reviewImageMarkup(containerItem)}
          <div class="tgb-final-review__item-copy"><strong>${escapeHtml(containerItem.title)}</strong></div>
          <span class="tgb-final-review__price">${containerItem.price}</span>
        </article>${reviewDetailsMarkup([
          { label: customization?.textProperty || "Personalization", value: customization?.textValue || "" },
          { label: customization?.fileProperty || "Uploaded image", value: customization?.fileName || "" },
        ])}`
      : '<p class="tgb-final-review__empty">No container selected.</p>';

    const giftsMarkup = gifts.length
      ? gifts.map((input) => reviewItemMarkup(input, { quantityControls: true })).join("")
      : '<p class="tgb-final-review__empty">No gift items selected.</p>';

    const cardMarkup = card
      ? `${reviewItemMarkup(card)}${reviewDetailsMarkup([
          { label: "Message", value: cardMessage.value.trim() },
          { label: "Signature", value: cardSignature.value.trim() },
        ])}`
      : '<p class="tgb-final-review__empty">No greeting card selected.</p>';

    const magnetValue = magnet
      ? magnetValues[String(magnet.dataset.variantId)] || magnetPersonalization.value.trim()
      : "";
    const cityKeepsakeMarkup = cityKeepsake
      ? reviewItemMarkup(cityKeepsake, { detail: "Made for this city gift" })
      : "";
    const magnetMarkup = magnet
      ? `${reviewItemMarkup(magnet, { detail: magnet.dataset.role === "scraper" ? "Custom engraved for the recipient" : "Personalized add-on" })}${reviewDetailsMarkup([
          { label: magnet.dataset.personalizationProperty || "Engraving", value: magnetValue },
        ])}`
      : "";
    const keepsakeMarkup =
      [cityKeepsakeMarkup, magnetMarkup].filter(Boolean).join("") ||
      '<p class="tgb-final-review__empty">No custom keepsake selected.</p>';

    const ribbonMarkup = ribbon
      ? `${reviewItemMarkup(ribbon)}${reviewDetailsMarkup([
          { label: "Left bow tail", value: root.querySelector("[data-ribbon-left]")?.value.trim() || "" },
          { label: "Right bow tail", value: root.querySelector("[data-ribbon-right]")?.value.trim() || "" },
        ])}`
      : '<p class="tgb-final-review__empty">Standard ribbon presentation selected.</p>';

    finalReviewContent.innerHTML = [
      reviewGroupMarkup(isCurated ? "Curated gift" : "Container", isCurated ? null : 1, containerMarkup),
      reviewGroupMarkup(isCurated ? "Add-ons" : "Gift items", 2, giftsMarkup),
      reviewGroupMarkup("Card & message", 3, cardMarkup),
      reviewGroupMarkup(magnet?.dataset.role === "scraper" ? "Custom BBQ scraper" : "Custom keepsake", 4, keepsakeMarkup),
      reviewGroupMarkup("Finishing touch", 5, ribbonMarkup),
    ].join("");
    finalReviewTotal.textContent = money.format(totalCents() / 100);
    if (!finalReviewConfirm.disabled) {
      finalReviewConfirm.textContent = `Confirm & Add to Cart · ${money.format(totalCents() / 100)}`;
    }
  }

  function validateGiftForReview() {
    if (isCurated && !gatewayIngredients.length) {
      errorNode.textContent = "This gift is temporarily unavailable because its contents could not be verified. Please choose another gift.";
      errorNode.hidden = false;
      return false;
    }
    for (let currentStep = 1; currentStep <= 5; currentStep += 1) {
      if (!validateStep(currentStep)) {
        const message = errorNode.textContent;
        if (finalReview && !finalReview.hidden) closeFinalReview({ restoreFocus: false });
        showStep(currentStep);
        errorNode.textContent = message;
        errorNode.hidden = false;
        return false;
      }
    }
    return true;
  }

  function openFinalReview() {
    if (!finalReview || !validateGiftForReview()) return;
    dispatchStepCompleted(5);
    reviewReturnFocus = document.activeElement;
    finalReviewError.hidden = true;
    finalReviewConfirm.disabled = false;
    renderFinalReview();
    finalReview.hidden = false;
    syncModalState();
    window.requestAnimationFrame(() => finalReview.querySelector(".tgb-final-review__close")?.focus());
  }

  function closeFinalReview({ restoreFocus = true } = {}) {
    if (!finalReview || finalReview.hidden || finalReviewConfirm.disabled) return;
    finalReview.hidden = true;
    syncModalState();
    if (restoreFocus) (reviewReturnFocus || summaryAction)?.focus?.();
    reviewReturnFocus = null;
  }

  function focusFinalReview(event) {
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      closeFinalReview();
      return;
    }
    if (event.key !== "Tab") return;
    const focusable = Array.from(
      finalReviewPanel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
    ).filter((node) => node.offsetParent !== null && !node.classList.contains("tgb-final-review__backdrop"));
    if (!focusable.length) {
      event.preventDefault();
      finalReviewPanel.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }


  function createGiftId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") return window.crypto.randomUUID();
    return `cyo-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function cookiesBlocked() {
    try {
      document.cookie = 'tgb_cookie_test=1; path=/; SameSite=Lax';
      const blocked = !document.cookie.includes('tgb_cookie_test=1');
      document.cookie = 'tgb_cookie_test=; path=/; max-age=0';
      return blocked;
    } catch (e) {
      return true;
    }
  }

  async function requestJson(path, options = {}) {
    const headers = { Accept: "application/json", ...(options.headers || {}) };
    if (typeof options.body === "string" && !headers["Content-Type"]) headers["Content-Type"] = "application/json";
    const response = await fetch(path, { credentials: "same-origin", ...options, headers });
    let body = {};
    try {
      body = await response.json();
    } catch {}
    if (!response.ok) {
      const error = new Error(body.description || body.message || `Shopify returned ${response.status}`);
      error.status = response.status;
      throw error;
    }
    return body;
  }

  // Public production labels accompany the existing native parent/child links.
  function giftReference(giftId) {
    return `G-${String(giftId).replace(/[^a-z0-9]/gi, "").slice(-12).toUpperCase()}`;
  }

  function giftLabels(giftId) {
    return {
      "Gift reference": giftReference(giftId),
      "Gift": selectedContainer().dataset.title || "Custom gift",
    };
  }

  function lineProperties(input, giftId) {
    const role = input.dataset.role || "gift";
    const properties = {
      ...giftLabels(giftId),
      _tgb_gift_id: giftId,
      _tgb_role: role,
      _tgb_source: isCurated ? "native_curated_v1" : "native_cyo_v2_6",
      _tgb_item_title: input.dataset.title || "",
    };
    if (role === "card") {
      properties["Card message"] = cardMessage.value.trim();
      if (cardSignature.value.trim()) properties.Signature = cardSignature.value.trim();
    }
    if (role === "keepsake") properties["City keepsake"] = "Selected for this city gift";
    if (role === "magnet" || role === "scraper") {
      const propertyName = input.dataset.personalizationProperty || "Engraving";
      properties[propertyName] = magnetPersonalization.value.trim();
      if (role === "magnet") properties["Personalized keepsake"] = "Optional personalized add-on purchase";
    }
    if (role === "ribbon") {
      const left = root.querySelector("[data-ribbon-left]").value.trim();
      const right = root.querySelector("[data-ribbon-right]").value.trim();
      if (left) properties["Left ribbon message"] = left;
      if (right) properties["Right ribbon message"] = right;
    }
    return properties;
  }

  function parentProperties(giftId) {
    const container = selectedContainer();
    const properties = {
      ...giftLabels(giftId),
      _tgb_gift_id: giftId,
      _tgb_role: "container",
      _tgb_source: isCurated ? "native_curated_v1" : "native_cyo_v2_6",
      _tgb_builder_mode: builderMode,
      _tgb_parent_type: isCurated ? "curated_gift" : "container",
      _tgb_builder_version: BUILD_VERSION,
      _tgb_source_gateway_product: gatewayProductId,
      _tgb_source_gateway_variant: gatewayVariantId,
      _tgb_container_product: container.dataset.productId || "",
      _tgb_container_title: container.dataset.title || "",
    };
    if (isCurated && gatewayIngredients.length) {
      properties["BOX CONTENTS"] = gatewayIngredients
        .map((item, index) => `${index + 1}. ${item}`)
        .join("\n");
    }
    return properties;
  }

  function expectedChildren(giftId) {
    return selectedInputs().map((input) => ({
      variantId: Number(input.dataset.variantId),
      quantity: quantityFor(input),
      properties: lineProperties(input, giftId),
    }));
  }

  function expectedParent(giftId) {
    const container = selectedContainer();
    const properties = parentProperties(giftId);
    const config = containerCustomizationConfig(container);
    const metadata = config ? readCustomizationMetadata(container) : null;
    const textValue = String(metadata?.textValue || "").trim();
    if (textValue) properties[metadata?.textProperty || config.textProperty || "Personalization"] = textValue;
    return {
      variantId: Number(container.dataset.variantId),
      properties,
      fileProperty: metadata?.fileKey ? (metadata.fileProperty || config.fileProperty || "Custom image") : null,
    };
  }

  function matchingProperties(actual, expected) {
    return Object.entries(expected).every(([key, value]) =>
      String(actual?.[key] ?? "").replace(/\r\n/g, "\n") === String(value ?? "").replace(/\r\n/g, "\n"));
  }

  const containerCustomizationConfigs = {
    "create-your-own-happy-mothers-day-custom-photo-gift-tote": {
      type: "image",
      heading: "Personalize Your ‘Happy Mother’s Day’ Photo Gift Tote",
      help: "Turn this Mother’s Day tote into a keepsake she’ll treasure—upload a favorite photo, then choose the Texas treats and thoughtful extras to tuck inside.",
      fileQuestion: "What photo would you like printed on the tote?",
      fileProperty: "Upload your photo",
    },
    "create-your-own-i-love-you-dad-custom-photo-tote": {
      type: "image",
      heading: "Add a Favorite Photo to Dad’s Gift Tote",
      help: "Give Dad a tote made just for him—upload the photo you want featured, then fill it with his favorite Texas snacks, sauces, and keepsakes.",
      fileQuestion: "What photo would you like printed on the tote?",
      fileProperty: "Upload your photo",
    },
    "create-your-own-i-love-you-mom-custom-photo-tote": {
      type: "image",
      heading: "Add a Favorite Photo to Mom’s Gift Tote",
      help: "Make Mom’s gift beautifully personal—upload a favorite photo, then choose Texas treats and thoughtful touches picked especially for her.",
      fileQuestion: "What photo would you like printed on the tote?",
      fileProperty: "Upload your photo",
    },
    "create-your-own-happy-floral-mothers-day-custom-photo-gift-tote": {
      type: "image",
      heading: "Personalize Your Floral Mother’s Day Photo Tote",
      help: "Pair the floral design with a photo that makes her smile, then build a Mother’s Day gift filled with Texas favorites chosen just for her.",
      fileQuestion: "What photo would you like printed on the tote?",
      fileProperty: "Upload your photo",
    },
    "create-your-own-happy-galentine-s-day-custom-photo-tote": {
      type: "image",
      heading: "Add a Favorite Photo to Your Galentine’s Gift Tote",
      help: "Celebrate the friendship with a favorite photo, then fill her tote with fun Texas sweets, self-care treats, and keepsakes.",
      fileQuestion: "What photo would you like printed on the tote?",
      fileProperty: "Upload your photo",
    },
    "create-your-own-your-friends-at-your-logo-appreciate-your-custom-gift-tote": {
      type: "image",
      heading: "Add Your Logo to the Corporate Appreciation Gift Tote",
      help: "Put your logo front and center, then build a memorable appreciation gift with Texas favorites for clients, teams, or special events.",
      fileQuestion: "What logo would you like printed on the tote?",
      fileProperty: "Upload your company logo",
    },
    "create-your-own-someone-in-yourcity-state-loves-me-gift-tote": {
      type: "text",
      heading: "Personalize Your ‘Someone in This Location Loves Me’ Gift Tote",
      help: "Add the city, state, ranch, or special place that makes the message meaningful, then fill the tote with Texas favorites that feel close to home.",
      textQuestion: "What location would you like printed?",
      textProperty: "Location",
    },
    "create-your-own-big-custom-hug-gift-tote": {
      type: "text",
      heading: "Personalize Your Big [Name] Hug Gift Tote",
      help: "Make the BIG [Name] HUG truly theirs—tell us the name or word to feature, then fill the tote with a warm mix of Texas favorites.",
      textQuestion: "What word would you like between ‘BIG’ and ‘HUG’?",
      textProperty: "Custom hug word",
    },
    "create-your-own-customized-bad-ass-bbq-gift-box": {
      type: "text",
      heading: "Engrave the Pitmaster’s Name on the Bad Ass BBQ Gift Box",
      help: "Put the pitmaster’s name on the box, then pack it with bold Texas sauces, savory snacks, and grilling favorites worthy of the title.",
      textQuestion: "What pitmaster name would you like engraved?",
      textProperty: "Pitmaster name",
    },
    "build-your-own-texas-pride-gift-box": {
      type: "either",
      heading: "Personalize the Texas Pride Gift Box Ribbon",
      help: "Add your company wording, logo, or both to the ribbon, then create a polished Texas gift box for clients, teams, or special events.",
      textQuestion: "What wording would you like printed on the ribbon?",
      textProperty: "Ribbon text",
      fileQuestion: "Or upload the company logo",
      fileProperty: "Company logo",
    },
  };

  containerCustomizationConfigs["create-your-own-texas-pride-gift-box"] =
    containerCustomizationConfigs["build-your-own-texas-pride-gift-box"];

  function containerCustomizationConfig(container = selectedContainer()) {
    if (!container) return null;

    const fallback = containerCustomizationConfigs[String(container.dataset.handle || "")] || null;
    const rawType = container.dataset.handle === "create-your-own-happy-floral-mothers-day-custom-photo-gift-tote"
      ? "both" : String(container.dataset.personalizationType || "").trim();
    const type = {
      both: "both",
      text: "text",
      image: "image",
      text_or_image: "either",
      either: "either",
    }[rawType];

    if (!type) return fallback;

    return {
      type,
      heading:
        String(container.dataset.personalizationHeading || "").trim() ||
        fallback?.heading ||
        "Personalize your container",
      help:
        String(container.dataset.personalizationHelp || "").trim() ||
        fallback?.help ||
        "Add the wording or image required for this container.",
      textQuestion:
        String(container.dataset.textQuestion || "").trim() ||
        fallback?.textQuestion ||
        "What wording would you like to add?",
      textProperty:
        String(container.dataset.textCartLabel || "").trim() ||
        fallback?.textProperty ||
        "Personalization text",
      fileQuestion:
        String(container.dataset.imageQuestion || "").trim() ||
        fallback?.fileQuestion ||
        "What image would you like to use?",
      fileProperty:
        String(container.dataset.imageCartLabel || "").trim() ||
        fallback?.fileProperty ||
        "Personalization image",
    };
  }

  function containerCustomizationStorageKey(container = selectedContainer()) {
    if (!container) return "";
    return `tgb-cyo-container-custom-${container.dataset.productId || ""}-${container.dataset.variantId || ""}`;
  }

  function readCustomizationMetadata(container = selectedContainer()) {
    if (!container) return null;
    try {
      const metadata = JSON.parse(window.sessionStorage.getItem(containerCustomizationStorageKey(container)) || "null");
      if (
        !metadata ||
        String(metadata.productId) !== String(container.dataset.productId || "") ||
        String(metadata.variantId) !== String(container.dataset.variantId || "")
      ) {
        return null;
      }
      return metadata;
    } catch {}
    return null;
  }

  function openCustomizationDatabase() {
    return new Promise((resolve, reject) => {
      if (!window.indexedDB) return resolve(null);
      const request = window.indexedDB.open("tgb-cyo-customizations", 1);
      request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains("files")) db.createObjectStore("files", { keyPath: "key" });
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  async function readCustomizationFile(key) {
    if (!key) return null;
    const db = await openCustomizationDatabase();
    if (!db) return null;
    return new Promise((resolve, reject) => {
      const transaction = db.transaction("files", "readonly");
      const request = transaction.objectStore("files").get(key);
      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => reject(request.error);
      transaction.oncomplete = () => db.close();
    });
  }

  async function deleteCustomizationFile(key) {
    if (!key) return;
    const db = await openCustomizationDatabase();
    if (!db) return;
    await new Promise((resolve, reject) => {
      const transaction = db.transaction("files", "readwrite");
      transaction.objectStore("files").delete(key);
      transaction.oncomplete = resolve;
      transaction.onerror = () => reject(transaction.error);
    });
    db.close();
  }

  async function saveCustomizationFile(container, file) {
    if (!container || !file) return null;
    const db = await openCustomizationDatabase();
    if (!db) throw new Error("This browser cannot retain the image while you build the gift. Please try another browser.");
    const key = `${containerCustomizationStorageKey(container)}-file`;
    await new Promise((resolve, reject) => {
      const transaction = db.transaction("files", "readwrite");
      transaction.objectStore("files").put({
        key,
        blob: file,
        name: file.name,
        type: file.type,
        updatedAt: Date.now(),
      });
      transaction.oncomplete = resolve;
      transaction.onerror = () => reject(transaction.error);
    });
    db.close();
    return key;
  }

  function commitContainerSelection(container, { returnToGifts = false } = {}) {
    if (!container) return;
    container.checked = true;
    committedContainer = container;
    errorNode.hidden = true;
    root.querySelectorAll("[data-cyo-container]").forEach(updateProductCard);
    updateSummary();
    saveDraft();
    if (returnToGifts) showStep(2);
  }

  function openContainerPersonalizationModal(container, previousContainer = committedContainer) {
    const config = containerCustomizationConfig(container);
    if (!container || !config || !containerPersonalizationModal) return;

    pendingContainer = container;
    containerSelectionBeforeModal = previousContainer || committedContainer;
    const metadata = readCustomizationMetadata(container);
    const needsText = config.type === "text" || config.type === "either" || config.type === "both";
    const needsFile = config.type === "image" || config.type === "either" || config.type === "both";
    const image = container.dataset.detailImage || container.dataset.image || "";

    containerPersonalizationTitle.textContent = config.heading || "Personalize your container";
    containerPersonalizationHelp.textContent = config.help || "Add the wording or image required for this container.";
    containerPersonalizationImage.src = image;
    containerPersonalizationImage.alt = container.dataset.title || "Selected container";
    containerPersonalizationImage.hidden = !image;

    containerPersonalizationTextField.hidden = !needsText;
    containerPersonalizationTextQuestion.textContent = config.textQuestion || "What wording would you like?";
    containerPersonalizationText.value = metadata?.textValue || "";
    containerPersonalizationText.removeAttribute("aria-invalid");

    containerPersonalizationFileField.hidden = !needsFile;
    containerPersonalizationFileQuestion.textContent = config.fileQuestion || "What image would you like to use?";
    containerPersonalizationFile.value = "";
    containerPersonalizationFileName.textContent = metadata?.fileName ? `Saved: ${metadata.fileName}` : "No file selected";
    containerPersonalizationFile.removeAttribute("aria-invalid");

    containerPersonalizationError.hidden = true;
    containerPersonalizationSave.disabled = false;
    containerPersonalizationSave.textContent = "Save & Use This Container";
    containerPersonalizationModal.hidden = false;
    syncModalState();
    window.requestAnimationFrame(() => (needsText ? containerPersonalizationText : containerPersonalizationFile)?.focus());
  }

  function closeContainerPersonalizationModal({ cancel = true } = {}) {
    if (!containerPersonalizationModal || containerPersonalizationModal.hidden) return;
    const chosenContainer = pendingContainer;
    if (cancel) {
      const previousContainer = containerSelectionBeforeModal || committedContainer;
      if (previousContainer) previousContainer.checked = true;
      root.querySelectorAll("[data-cyo-container]").forEach(updateProductCard);
      updateSummary();
      saveDraft();
    } else if (chosenContainer) {
      commitContainerSelection(chosenContainer);
    }

    containerPersonalizationModal.hidden = true;
    pendingContainer = null;
    containerSelectionBeforeModal = null;
    syncModalState();

    if (!cancel && chosenContainer) showStep(2);
  }

  async function saveContainerPersonalizationModal() {
    const container = pendingContainer;
    const config = containerCustomizationConfig(container);
    if (!container || !config) return;

    const textValue = String(containerPersonalizationText.value || "").trim();
    const file = containerPersonalizationFile.files?.[0] || null;
    const existing = readCustomizationMetadata(container);
    let savedFileRecord = null;
    try {
      if (existing?.fileKey) savedFileRecord = await readCustomizationFile(existing.fileKey);
    } catch {}
    const hasSavedFile = Boolean(savedFileRecord?.blob);

    if ((config.type === "text" || config.type === "both") && !textValue) {
      containerPersonalizationError.textContent = "Please answer the personalization question before continuing.";
      containerPersonalizationError.hidden = false;
      containerPersonalizationText.setAttribute("aria-invalid", "true");
      containerPersonalizationText.focus();
      return;
    }
    if ((config.type === "image" || config.type === "both") && !file && !hasSavedFile) {
      containerPersonalizationError.textContent = "Please choose the image to print before continuing.";
      containerPersonalizationError.hidden = false;
      containerPersonalizationFile.setAttribute("aria-invalid", "true");
      containerPersonalizationFile.focus();
      return;
    }
    if (config.type === "either" && !textValue && !file && !hasSavedFile) {
      containerPersonalizationError.textContent = "Please enter ribbon wording or upload a company logo before continuing.";
      containerPersonalizationError.hidden = false;
      containerPersonalizationText.setAttribute("aria-invalid", "true");
      containerPersonalizationText.focus();
      return;
    }

    containerPersonalizationSave.disabled = true;
    containerPersonalizationSave.textContent = "Saving…";
    containerPersonalizationError.hidden = true;

    try {
      const savedFileKey = file ? await saveCustomizationFile(container, file) : existing?.fileKey || null;
      const metadata = {
        schemaVersion: 1,
        productId: String(container.dataset.productId || ""),
        variantId: String(container.dataset.variantId || ""),
        handle: String(container.dataset.handle || ""),
        type: config.type,
        textProperty: config.textProperty || "",
        textValue,
        fileProperty: config.fileProperty || "",
        fileKey: savedFileKey,
        fileName: file?.name || existing?.fileName || "",
      };
      window.sessionStorage.setItem(containerCustomizationStorageKey(container), JSON.stringify(metadata));
      closeContainerPersonalizationModal({ cancel: false });
    } catch (error) {
      containerPersonalizationError.textContent = error.message || "The personalization could not be saved. Please try again.";
      containerPersonalizationError.hidden = false;
      containerPersonalizationSave.disabled = false;
      containerPersonalizationSave.textContent = "Save & Use This Container";
    }
  }

  async function addParentLine(giftId) {
    const container = selectedContainer();
    const form = new FormData();
    form.append("id", String(container.dataset.variantId));
    form.append("quantity", "1");
    Object.entries(parentProperties(giftId)).forEach(([name, value]) => form.append(`properties[${name}]`, value));

    const config = containerCustomizationConfig(container);
    const metadata = readCustomizationMetadata(container);
    let fileRecord = null;
    if (metadata?.fileKey) fileRecord = await readCustomizationFile(metadata.fileKey);

    if (config) {
      const textValue = String(metadata?.textValue || "").trim();
      if ((config.type === "text" || config.type === "both") && !textValue) throw new Error("Return to Step 1 and enter the selected container’s required personalization.");
      if ((config.type === "image" || config.type === "both") && !fileRecord?.blob) throw new Error("Return to Step 1 and upload the selected container’s required image.");
      if (config.type === "either" && !textValue && !fileRecord?.blob) throw new Error("Return to Step 1 and enter ribbon text or upload a company logo.");
      if (textValue) form.append(`properties[${metadata?.textProperty || config.textProperty || "Personalization"}]`, textValue);
      if (fileRecord?.blob) {
        const file = new File([fileRecord.blob], fileRecord.name || "customization-upload", {
          type: fileRecord.type || fileRecord.blob.type || "application/octet-stream",
        });
        form.append(`properties[${metadata?.fileProperty || config.fileProperty || "Custom image"}]`, file, file.name);
      }
    }

    await requestJson("/cart/add.js", { method: "POST", body: form });
    // The add response can contain a superseded key after cart processing.
    // Resolve this gift from the current cart before attaching its children.
    const cart = await requestJson("/cart.js", { cache: "no-store" });
    const parent = cart.items.find(
      (item) => item.properties?._tgb_gift_id === giftId && item.properties?._tgb_role === "container",
    );
    if (!parent?.key) throw new Error("The container was added, but Shopify did not return its line key.");
    return { key: parent.key, metadata };
  }

  async function addChildLines(giftId, parentLineKey) {
    const items = selectedInputs().map((input) => ({
      id: Number(input.dataset.variantId),
      quantity: quantityFor(input),
      parent_line_key: parentLineKey,
      properties: lineProperties(input, giftId),
    }));
    if (!items.length) return null;
    try {
      return await requestJson("/cart/add.js", { method: "POST", body: JSON.stringify({ items }) });
    } catch (error) {
      if (error.status !== 422 || !/parent line does not match/i.test(error.message || "")) throw error;
      // Retry only a rejected link using a freshly resolved parent. Never replay
      // a timeout, a successful add, or a gift that already has child lines.
      const cart = await requestJson("/cart.js", { cache: "no-store" });
      const lines = cart.items.filter((item) => item.properties?._tgb_gift_id === giftId);
      const parents = lines.filter((item) => item.properties?._tgb_role === "container");
      if (parents.length !== 1 || !parents[0].key || Number(parents[0].quantity) !== 1 ||
          lines.some((item) => item.properties?._tgb_role !== "container")) throw error;
      items.forEach((item) => { item.parent_line_key = parents[0].key; });
      return requestJson("/cart/add.js", { method: "POST", body: JSON.stringify({ items }) });
    }
  }

  function verifyGift(cart, giftId, expected, wantedParent) {
    const lines = cart.items.filter((item) => item.properties?._tgb_gift_id === giftId);
    const parents = lines.filter((item) => item.properties?._tgb_role === "container");
    const parent = parents[0];
    const children = lines.filter((item) => item.properties?._tgb_role !== "container");
    const expectedIds = new Set(expected.map((item) => item.variantId));
    const missing = [];
    const duplicates = [];
    const quantityMismatches = [];
    const propertyMismatches = [];

    expected.forEach((wanted) => {
      const matches = children.filter((item) => Number(item.variant_id) === wanted.variantId);
      if (!matches.length) missing.push(wanted.variantId);
      if (matches.length > 1) duplicates.push(wanted.variantId);
      if (matches.some((item) => !matchingProperties(item.properties, wanted.properties))) {
        propertyMismatches.push(wanted.variantId);
      }
      const quantity = matches.reduce((total, item) => total + Number(item.quantity || 0), 0);
      if (matches.length && quantity !== wanted.quantity) {
        quantityMismatches.push({ variantId: wanted.variantId, expected: wanted.quantity, actual: quantity });
      }
    });

    const unexpected = children.filter((item) => !expectedIds.has(Number(item.variant_id)));
    const unlinked = parent
      ? children.filter((item) => item.parent_relationship?.parent_key !== parent.key)
      : children;
    const missingBoxContents = isCurated && !String(parent?.properties?.["BOX CONTENTS"] || "").trim();
    const parentMismatch = parents.length !== 1 || Number(parent?.variant_id) !== wantedParent.variantId ||
      !matchingProperties(parent?.properties, wantedParent.properties) ||
      (wantedParent.fileProperty && !String(parent?.properties?.[wantedParent.fileProperty] || "").trim());
    const referenceCollision = cart.items.some((item) =>
      item.properties?.["Gift reference"] === wantedParent.properties["Gift reference"] &&
      item.properties?._tgb_gift_id !== giftId);
    const passed =
      Boolean(parent) && !parentMismatch && !referenceCollision && propertyMismatches.length === 0 &&
      Number(parent.quantity) === 1 &&
      missing.length === 0 &&
      duplicates.length === 0 &&
      quantityMismatches.length === 0 &&
      unexpected.length === 0 &&
      unlinked.length === 0 &&
      !missingBoxContents;

    return { lines, parent, children, missing, duplicates, quantityMismatches, unexpected, unlinked, missingBoxContents, parentMismatch, referenceCollision, propertyMismatches, passed };
  }

  async function removeGiftLines(giftId) {
    let cart = await requestJson("/cart.js");
    let lines = cart.items.filter((item) => item.properties?._tgb_gift_id === giftId);
    const parent = lines.find((item) => item.properties?._tgb_role === "container");
    if (parent) {
      try {
        await requestJson("/cart/change.js", { method: "POST", body: JSON.stringify({ id: parent.key, quantity: 0 }) });
      } catch {}
    }
    cart = await requestJson("/cart.js");
    lines = cart.items.filter((item) => item.properties?._tgb_gift_id === giftId);
    for (const line of lines) {
      try {
        await requestJson("/cart/change.js", { method: "POST", body: JSON.stringify({ id: line.key, quantity: 0 }) });
      } catch {}
    }
    cart = await requestJson("/cart.js");
    return cart.items.filter((item) => item.properties?._tgb_gift_id === giftId).length === 0;
  }

  async function addGiftToCart() {
    if (cookiesBlocked()) {
      const payload = { gift_path: "customize_builder", send_to: "G-SLBLC61301" };
      if (typeof window.gtag === "function") {
        window.gtag("event", "gift_builder_cookies_blocked", payload);
      } else {
        window.dataLayer = window.dataLayer || [];
        (function () { window.dataLayer.push(arguments); })("event", "gift_builder_cookies_blocked", payload);
      }
      const cookieMessage = "Your browser is blocking cookies for this site, so items cannot be added to your cart. Please allow cookies for texasgiftbaskets.com and try again.";
      if (finalReview && !finalReview.hidden && finalReviewError) {
        finalReviewError.textContent = cookieMessage;
        finalReviewError.hidden = false;
      } else {
        errorNode.textContent = cookieMessage;
        errorNode.hidden = false;
      }
      return;
    }
    if (!validateGiftForReview()) return;

    const giftId = createGiftId();
    const expected = expectedChildren(giftId);
    const wantedParent = expectedParent(giftId);
    const originalLabel = summaryAction.textContent;
    const launchedFromReview = finalReview && !finalReview.hidden;
    const reviewOriginalLabel = finalReviewConfirm?.textContent || "Confirm & Add to Cart";
    summaryAction.disabled = true;
    summaryAction.textContent = "Linking your gift…";
    if (finalReviewConfirm) {
      finalReviewConfirm.disabled = true;
      finalReviewConfirm.textContent = "Adding your gift…";
    }
    errorNode.hidden = true;
    if (finalReviewError) finalReviewError.hidden = true;

    let customizationMetadata = null;
    try {
      const parentResult = await addParentLine(giftId);
      customizationMetadata = parentResult.metadata;
      await addChildLines(giftId, parentResult.key);
      const cart = await requestJson("/cart.js");
      const check = verifyGift(cart, giftId, expected, wantedParent);
      if (!check.passed) {
        const reasons = [];
        if (!check.parent) reasons.push("container line missing");
        if (check.parentMismatch) reasons.push("gift details did not save correctly");
        if (check.referenceCollision) reasons.push("gift reference already in use");
        if (check.propertyMismatches.length) reasons.push("item details or personalization did not save correctly");
        if (check.missingBoxContents) reasons.push("BOX CONTENTS missing");
        if (check.missing.length) reasons.push(`${check.missing.length} item(s) missing`);
        if (check.duplicates.length) reasons.push(`${check.duplicates.length} duplicate item(s)`);
        if (check.quantityMismatches.length) reasons.push(`${check.quantityMismatches.length} quantity mismatch(es)`);
        if (check.unexpected.length) reasons.push(`${check.unexpected.length} unexpected item(s)`);
        if (check.unlinked.length) reasons.push(`${check.unlinked.length} unlinked item(s)`);
        const cleaned = await removeGiftLines(giftId);
        if (!cleaned) throw new Error("The cart contains an incomplete gift that could not be removed automatically. Checkout is paused; please refresh the cart or contact us.");
        throw new Error(`Cart verification found ${reasons.join(", ")}. The incomplete gift was removed.`);
      }

      try {
        window.sessionStorage.removeItem(storageKey);
        window.sessionStorage.removeItem(containerCustomizationStorageKey(selectedContainer()));
      } catch {}
      if (customizationMetadata?.fileKey) {
        try {
          await deleteCustomizationFile(customizationMetadata.fileKey);
        } catch {}
      }
      window.dispatchEvent(new CustomEvent("tgb:builder-completed", {
        detail: {
          builderMode,
          itemCount: expected.length + 1
        }
      }));
      window.location.assign("/cart");
    } catch (error) {
      window.dispatchEvent(new CustomEvent("tgb:builder-error", {
        detail: {
          builderMode,
          errorStage: "cart_add"
        }
      }));
      try {
        await removeGiftLines(giftId);
      } catch {}
      const cartError = `${error.status === 422 ? "Shopify rejected this combination. " : ""}${
        error.message || "The linked gift could not be added."
      }`;
      if (launchedFromReview && finalReviewError) {
        finalReviewError.textContent = cartError;
        finalReviewError.hidden = false;
      } else {
        errorNode.textContent = cartError;
        errorNode.hidden = false;
      }
      summaryAction.disabled = false;
      summaryAction.textContent = originalLabel;
      if (finalReviewConfirm) {
        finalReviewConfirm.disabled = false;
        finalReviewConfirm.textContent = reviewOriginalLabel;
      }
    }
  }

  function changeGiftQuantity(variantId, delta) {
    const input = root.querySelector(`[data-cyo-item][data-variant-id="${CSS.escape(variantId)}"]`);
    if (!input || input.dataset.role !== "gift") return;
    const current = quantityFor(input);
    const max = Math.max(1, Number(input.dataset.maxQuantity || 10));
    const next = Math.max(0, Math.min(max, current + delta));
    if (next === 0) {
      input.checked = false;
      quantities.delete(variantId);
    } else {
      input.checked = true;
      quantities.set(variantId, next);
    }
    updateProductCard(input);
    updateSummary();
    if (finalReview && !finalReview.hidden) renderFinalReview();
    if (quickViewInput === input) renderQuickViewAction();
    saveDraft();
  }

  function removeSummaryItem(variantId, role) {
    const input = root.querySelector(`[data-cyo-item][data-variant-id="${CSS.escape(variantId)}"]`);
    if (!input) return;
    if (role === "card") {
      const none = root.querySelector('input[name="cyo_card"][value="none"]');
      if (none) none.checked = true;
      input.checked = false;
      clearCardDraft();
      updateCardState();
    } else if (role === "magnet" || role === "scraper") {
      const none = root.querySelector('input[name="cyo_magnet"][value="none"]');
      if (none) none.checked = true;
      input.checked = false;
      delete magnetValues[String(variantId)];
      updateMagnetState();
    } else {
      input.checked = false;
      quantities.delete(String(variantId));
      updateDependentFields(input);
      updateProductCard(input);
    }
    if (quickViewInput === input) renderQuickViewAction();
    updateSummary();
    saveDraft();
  }

  summaryAction.addEventListener("click", () => {
    if (step < 5) {
      if (!validateStep(step)) return;
      dispatchStepCompleted(step);
      showStep(step + 1);
      return;
    }
    openFinalReview();
  });

  finalReview?.addEventListener("click", (event) => {
    const closeButton = event.target.closest("[data-final-review-close]");
    if (closeButton) {
      closeFinalReview();
      return;
    }

    const editButton = event.target.closest("[data-final-review-edit]");
    if (editButton) {
      const editStep = Number(editButton.dataset.finalReviewEdit || 1);
      closeFinalReview({ restoreFocus: false });
      showStep(editStep);
      window.requestAnimationFrame(() => root.querySelector(`[data-step-panel="${editStep}"]`)?.focus?.());
      return;
    }

    const quantityButton = event.target.closest("[data-final-review-quantity]");
    if (quantityButton) {
      changeGiftQuantity(
        String(quantityButton.dataset.variantId || ""),
        Number(quantityButton.dataset.finalReviewQuantity || 0),
      );
    }
  });
  finalReview?.addEventListener("keydown", focusFinalReview);
  finalReviewConfirm?.addEventListener("click", () => addGiftToCart());

  stepTriggers.forEach((trigger) =>
    trigger.addEventListener("click", () => {
      const requested = Number(trigger.dataset.stepTrigger);
      if (requested <= maxStep) showStep(requested);
    }),
  );

  root.addEventListener("click", (event) => {
    const changeContainerButton = event.target.closest("[data-change-container]");
    if (changeContainerButton && !isCurated) {
      event.preventDefault();
      setSummaryExpanded(false);
      showStep(1);
      return;
    }

    const quantityButton = event.target.closest("[data-card-quantity]");
    if (quantityButton) {
      event.preventDefault();
      event.stopPropagation();
      changeGiftQuantity(String(quantityButton.dataset.variantId || ""), Number(quantityButton.dataset.cardQuantity || 0));
      return;
    }

    const quickAdd = event.target.closest("[data-quick-view-add]");
    if (quickAdd && quickViewInput) {
      event.preventDefault();
      quickViewInput.checked = true;
      normalizeQuantity(quickViewInput);
      updateProductCard(quickViewInput);
      updateSummary();
      renderQuickViewAction();
      saveDraft();
      return;
    }

    const removeButton = event.target.closest("[data-summary-remove]");
    if (removeButton) {
      event.preventDefault();
      removeSummaryItem(String(removeButton.dataset.summaryRemove || ""), String(removeButton.dataset.summaryRole || ""));
      return;
    }

    const clearContainerFilter = event.target.closest("[data-clear-container-filters]");
    if (clearContainerFilter) {
      event.preventDefault();
      const allType = root.querySelector('input[name="cyo_container_type"][value="all"]');
      const allOccasion = root.querySelector('input[name="cyo_container_occasion"][value="all"]');
      if (allType) allType.checked = true;
      if (allOccasion) allOccasion.checked = true;
      if (containerSearch) containerSearch.value = "";
      applyContainerFilters();
      return;
    }

    const containerContinueButton = event.target.closest("[data-container-continue]");
    if (containerContinueButton) {
      event.preventDefault();
      if (validateStep(1)) {
        dispatchStepCompleted(1);
        showStep(2);
      }
      return;
    }

    const clearFilter = event.target.closest("[data-clear-filter]");
    if (clearFilter) {
      event.preventDefault();
      const target = clearFilter.dataset.clearFilter;
      if (target === "category" || target === "all") root.querySelector('input[name="cyo_category"][value="all"]').checked = true;
      if (target === "region" || target === "all") root.querySelector('input[name="cyo_region"][value="all"]').checked = true;
      if (target === "search" || target === "all") searchInput.value = "";
      applyFilters();
      return;
    }

    const quickTrigger = event.target.closest("[data-quick-view-trigger]");
    if (quickTrigger) {
      event.preventDefault();
      event.stopPropagation();
      openQuickView(quickTrigger.closest("[data-product-card]"), quickTrigger);
    }
  });

  root.addEventListener("keydown", (event) => {
    const quickTrigger = event.target.closest?.("[data-quick-view-trigger]");
    if (!quickTrigger || !["Enter", " "].includes(event.key)) return;
    event.preventDefault();
    openQuickView(quickTrigger.closest("[data-product-card]"), quickTrigger);
  });

  root.querySelectorAll("[data-cyo-container]").forEach((input) => {
    input.addEventListener("change", () => {
      const config = containerCustomizationConfig(input);
      if (config && input !== committedContainer) {
        errorNode.hidden = true;
        root.querySelectorAll("[data-cyo-container]").forEach(updateProductCard);
        updateSummary();
        openContainerPersonalizationModal(input, committedContainer);
        return;
      }
      commitContainerSelection(input);
    });
  });

  root.querySelectorAll('[data-cyo-item]:not([data-role="card"]):not([data-role="magnet"]):not([data-role="scraper"])').forEach((input) => {
    input.addEventListener("change", () => {
      errorNode.hidden = true;
      normalizeQuantity(input);
      updateDependentFields(input);
      updateProductCard(input);
      updateSummary();
      saveDraft();
    });
  });

  function scheduleCardSelection(input) {
    window.clearTimeout(cardSelectionTimer);
    cardSelectionTimer = window.setTimeout(() => {
      errorNode.hidden = true;
      if (input.value === "none") {
        clearCardDraft();
        updateCardState();
        updateSummary();
        saveDraft();
        return;
      }
      if (input.checked) openCardModal(input, cardSelectionOnPointerDown || input);
    }, 0);
  }

  root.querySelectorAll('.tgb-choice-card input[name="cyo_card"]').forEach((input) => {
    const choice = input.closest(".tgb-choice-card");
    choice.addEventListener("pointerdown", () => {
      cardSelectionOnPointerDown = root.querySelector('input[name="cyo_card"]:checked');
    });
    choice.addEventListener("click", () => {
      if (input.disabled) return;
      scheduleCardSelection(input);
    });
    input.addEventListener("change", () => scheduleCardSelection(input));
  });

  function scheduleMagnetSelection(input) {
    window.clearTimeout(magnetSelectionTimer);
    magnetSelectionTimer = window.setTimeout(() => {
      errorNode.hidden = true;
      magnetPersonalization.removeAttribute("aria-invalid");
      if (input.value === "none") {
        updateMagnetState();
        updateSummary();
        saveDraft();
        return;
      }
      if (input.checked) openMagnetModal(input, magnetSelectionOnPointerDown || input);
    }, 0);
  }

  root.querySelectorAll('.tgb-choice-card input[name="cyo_magnet"]').forEach((input) => {
    const choice = input.closest(".tgb-choice-card");
    choice.addEventListener("pointerdown", () => {
      magnetSelectionOnPointerDown = root.querySelector('input[name="cyo_magnet"]:checked');
    });
    choice.addEventListener("click", () => {
      if (input.disabled) return;
      scheduleMagnetSelection(input);
    });
    input.addEventListener("change", () => scheduleMagnetSelection(input));
  });

  cardMessage.addEventListener("input", () => {
    errorNode.hidden = true;
    cardModalError.hidden = true;
    cardMessage.removeAttribute("aria-invalid");
    saveDraft();
  });
  cardSignature.addEventListener("input", saveDraft);
  cardModalSave.addEventListener("click", saveCardModal);
  root.querySelectorAll("[data-card-modal-close]").forEach((button) =>
    button.addEventListener("click", () => closeCardModal({ cancel: true })),
  );

  magnetModalSave.addEventListener("click", saveMagnetModal);
  root.querySelectorAll("[data-magnet-modal-close]").forEach((button) =>
    button.addEventListener("click", () => closeMagnetModal({ cancel: true })),
  );

  containerPersonalizationSave?.addEventListener("click", saveContainerPersonalizationModal);
  root.querySelectorAll("[data-container-personalization-close]").forEach((button) =>
    button.addEventListener("click", () => closeContainerPersonalizationModal({ cancel: true })),
  );
  containerPersonalizationText?.addEventListener("input", () => {
    containerPersonalizationError.hidden = true;
    containerPersonalizationText.removeAttribute("aria-invalid");
  });
  containerPersonalizationFile?.addEventListener("change", () => {
    containerPersonalizationFileName.textContent = containerPersonalizationFile.files?.[0]?.name || "No file selected";
    containerPersonalizationError.hidden = true;
    containerPersonalizationFile.removeAttribute("aria-invalid");
  });

  magnetPersonalization.addEventListener("input", () => {
    const magnet = selectedMagnet();
    if (magnet) magnetValues[String(magnet.dataset.variantId)] = magnetPersonalization.value;
    errorNode.hidden = true;
    magnetModalError.hidden = true;
    magnetPersonalization.removeAttribute("aria-invalid");
    saveDraft();
  });

  root.querySelectorAll("[data-ribbon-left], [data-ribbon-right]").forEach((field) => {
    field.addEventListener("input", () => {
      errorNode.hidden = true;
      field.removeAttribute("aria-invalid");
      updateRibbonCharacterCounts();
      saveDraft();
    });
  });

  root.querySelectorAll('input[name="cyo_category"], input[name="cyo_region"]').forEach((input) =>
    input.addEventListener("change", () => applyFilters()),
  );
  [...containerTypeInputs, ...containerOccasionInputs].forEach((input) =>
    input.addEventListener("change", () => applyContainerFilters()),
  );
  containerSearch?.addEventListener("input", () => applyContainerFilters());
  searchInput.addEventListener("input", () => applyFilters());
  cardFilterButtons.forEach((button) => {
    button.addEventListener("click", () => {
      cardFilter = button.dataset.cardFilterButton || "all";
      applyCardFilters();
    });
  });
  if (window.innerWidth < 981) {
    filterToggle.setAttribute("aria-expanded", "false");
    filterBody.hidden = true;
  } else {
    filterToggle.setAttribute("aria-expanded", "true");
    filterBody.hidden = false;
  }
  filterToggle.addEventListener("click", () => {
    const expanded = filterToggle.getAttribute("aria-expanded") === "true";
    filterToggle.setAttribute("aria-expanded", String(!expanded));
    filterBody.hidden = expanded;
    saveDraft();
  });

  summaryToggle?.addEventListener("click", () => {
    setSummaryExpanded(summaryToggle.getAttribute("aria-expanded") !== "true");
  });

  headerGiftButton?.addEventListener("click", () => {
    if (window.innerWidth < 981) {
      setSummaryExpanded(true);
      summaryToggle?.focus();
    } else {
      summaryPanel?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  root.querySelectorAll("[data-builder-exit]").forEach((link) => {
    link.addEventListener("click", (event) => {
      if (!selectedInputs().length) return;
      const shouldLeave = window.confirm("Leave the gift builder? Your selections will remain saved for this visit.");
      if (!shouldLeave) event.preventDefault();
    });
  });

  quickViewReadMore?.addEventListener("click", () => {
    const expanded = quickViewDescription.classList.toggle("is-expanded");
    quickViewReadMore.textContent = expanded ? "Show less" : "Read more";
  });
  root.querySelectorAll("[data-quick-view-close]").forEach((button) => button.addEventListener("click", closeQuickView));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && containerPersonalizationModal && !containerPersonalizationModal.hidden) {
      closeContainerPersonalizationModal({ cancel: true });
    }
    else if (event.key === "Escape" && !quickViewModal.hidden) closeQuickView();
    else if (event.key === "Escape" && !cardModal.hidden) closeCardModal({ cancel: true });
    else if (event.key === "Escape" && !magnetModal.hidden) closeMagnetModal({ cancel: true });
  });

  root.querySelectorAll(".tgb-builder__notice").forEach((notice) => {
    if (/draft\s+pilot/i.test(notice.textContent || "")) notice.remove();
  });
  root.querySelectorAll(".tgb-option-panel--future").forEach((panel) => panel.remove());

  try {
    await loadRemainingGiftPages();
  } catch {}
  prepareCatalogMetadata();
  moveUnavailableProductsToEnd();
  updateFilterAvailability();
  const restored = restoreDraft();
  if (containerScope === "bucees") {
    const heading = root.querySelector(".tgb-container-heading h2");
    const copy = root.querySelector(".tgb-container-heading > span");
    const toolbarCopy = root.querySelector(".tgb-container-picker__toolbar span");
    const heroCopy = root.querySelector(".tgb-builder__hero > p:not(.tgb-builder__eyebrow)");
    const allType = root.querySelector('input[name="cyo_container_type"][value="all"]');
    const allOccasion = root.querySelector('input[name="cyo_container_occasion"][value="all"]');
    if (heading) heading.textContent = "Choose Your Buc-ee's Container";
    if (copy) copy.textContent = "Choose from the Buc-ee's-themed containers below, then continue directly to gifts.";
    if (toolbarCopy) toolbarCopy.textContent = "Only Buc-ee's-themed containers are shown for this gift.";
    if (heroCopy) heroCopy.textContent = "Start by choosing your Buc-ee's container below. You'll add gifts and personal touches next.";
    if (containerContinue) containerContinue.textContent = "Use This Container & Continue to Gifts";
    if (allType) allType.checked = true;
    if (allOccasion) allOccasion.checked = true;
    if (containerSearch) containerSearch.value = "";
    root.querySelectorAll(".tgb-container-card .tgb-product-card__image img").forEach((image) => {
      const originalSource = image.getAttribute("src") || image.currentSrc;
      if (!originalSource) return;
      const imageUrl = new URL(originalSource, window.location.origin);
      imageUrl.searchParams.delete("width");
      const sourceAtWidth = (width) => {
        const candidate = new URL(imageUrl.toString());
        candidate.searchParams.set("width", String(width));
        return candidate.toString();
      };
      image.sizes = "(min-width: 1200px) 310px, (min-width: 761px) 30vw, 92vw";
      image.srcset = [360, 540, 720, 900]
        .map((width) => `${sourceAtWidth(width)} ${width}w`)
        .join(", ");
      image.src = sourceAtWidth(900);
    });
  }
  committedContainer = selectedContainer();
  updateRibbonCharacterCounts();
  root.querySelectorAll("[data-cyo-container]").forEach(updateProductCard);
  root.querySelectorAll("[data-cyo-item]").forEach((input) => {
    normalizeQuantity(input);
    updateDependentFields(input, { focus: input.dataset.role === "ribbon" && input.checked });
    updateProductCard(input);
  });
  updateCardState();
  updateMagnetState();
  applyFilters({ persist: false });
  applyContainerFilters({ persist: false });
  applyCardFilters({ persist: false });
  updateSummary();
  window.requestAnimationFrame(() => {
    root.classList.add("is-catalog-ready");
    root.setAttribute("aria-busy", "false");
    summaryPanel?.setAttribute("aria-busy", "false");
    headerGiftButton?.removeAttribute("disabled");
    headerGiftButton?.setAttribute("aria-label", "Open your gift summary");
  });
  maxStep = restored.maxStep;
  const initialStep = !isCurated && requestedEntryStep === 1 ? 1 : restored.step;
  showStep(initialStep, { scroll: false, persist: false });
  saveDraft();
  if (restored.legacyKey) {
    saveDraft();
    try {
      window.sessionStorage.removeItem(restored.legacyKey);
    } catch {}
  }
})();



/* Embedded telemetry fallback: kept inside the core builder so privacy extensions cannot block a separate tracking-named asset. */
(function(){"use strict";if(window.__tgbBuilderAnalyticsLoaded)return;window.__tgbBuilderAnalyticsLoaded=!0;var MEASUREMENT_ID="G-SLBLC61301",ENTRY_CONTEXT_KEY="tgb_builder_entry_context",ENTRY_CONTEXT_MAX_AGE_MS=1800*1e3,STEP_NAMES={1:"container",2:"gift_items",3:"card_and_message",4:"custom_keepsake",5:"finishing_touch"},root=null,loadedAt=0,enteredAt=0,ready=!1,started=!1,viewedSteps={},completedSteps={},debugEvents=[];window.__tgbBuilderAnalytics={events:debugEvents};function cleanValue(value){if(value!=null){if(typeof value=="string"){var trimmed=value.trim();return trimmed?trimmed.slice(0,100):void 0}if(typeof value=="number")return Number.isFinite(value)?value:void 0;if(typeof value=="boolean")return value}}function deviceType(){return window.matchMedia&&window.matchMedia("(max-width: 767px)").matches?"mobile":window.matchMedia&&window.matchMedia("(max-width: 1023px)").matches?"tablet":"desktop"}function pagePath(){return(window.location.pathname||"/").toLowerCase()}function classifyEntryLocation(trigger,mode){var explicit=trigger&&trigger.closest("[data-tgb-entry-location]"),path=pagePath();return explicit&&explicit.dataset.tgbEntryLocation?explicit.dataset.tgbEntryLocation:trigger&&trigger.closest("header, nav, [role='navigation'], .shopify-section-header")?"site_navigation":path==="/"?"homepage":path.indexOf("/pages/create-your-own-texas-gift")===0?"cyo_landing_page":path.indexOf("/collections/")===0?"collection_page":path.indexOf("/products/")===0&&mode==="curated"?"curated_product_page":path.indexOf("/products/")===0&&mode==="cyo"?"cyo_product_page":path.indexOf("/products/")===0?"product_page":trigger?"other_cta":"direct_builder_entry"}function isCyoDestination(link){if(!link||!link.href)return!1;try{var destinationPath=new URL(link.href,window.location.href).pathname.toLowerCase();return destinationPath.indexOf("/pages/create-your-own-texas-gift")===0||destinationPath.indexOf("/collections/create-your-own")===0||destinationPath.indexOf("/products/create-your-own")===0}catch(error){return!1}}function storeEntryContext(location,mode){try{window.sessionStorage.setItem(ENTRY_CONTEXT_KEY,JSON.stringify({location:location,mode:mode,capturedAt:Date.now()}))}catch(error){return}}function storedEntryLocation(){try{var stored=JSON.parse(window.sessionStorage.getItem(ENTRY_CONTEXT_KEY)||"null");if(!stored||!stored.location||!stored.capturedAt)return;if(Date.now()-stored.capturedAt>ENTRY_CONTEXT_MAX_AGE_MS){window.sessionStorage.removeItem(ENTRY_CONTEXT_KEY);return}return stored.location}catch(error){return}}function builderContext(modeOverride,sourceOverride,locationOverride){var mode=modeOverride||root&&root.dataset.builderMode||"unknown";return{builder_mode:mode,builder_version:root&&root.dataset.builderVersion||"2.18-box-contents",builder_entry_source:new URLSearchParams(window.location.search).get("builder_entry_source")||void 0,entry_source:sourceOverride||(mode==="curated"?"curated_product":mode==="cyo"?"cyo_product":"unknown"),entry_location:locationOverride||storedEntryLocation()||classifyEntryLocation(null,mode),gateway_product_id:root&&root.dataset.gatewayProductId,gateway_variant_id:root&&root.dataset.gatewayVariantId,gateway_product_title:root&&root.dataset.gatewayTitle,device_type:deviceType()}}function sendEvent(name,parameters){var payload={},values=Object.assign({},parameters||{});Object.keys(values).forEach(function(key){var cleaned=cleanValue(values[key]);cleaned!==void 0&&(payload[key]=cleaned)}),payload.send_to=MEASUREMENT_ID,debugEvents.push({name:name,parameters:Object.assign({},payload),timestamp:Date.now()}),debugEvents.length>50&&debugEvents.shift(),typeof window.gtag=="function"?window.gtag("event",name,payload):(window.dataLayer=window.dataLayer||[],(function(){window.dataLayer.push(arguments)})("event",name,payload)),document.dispatchEvent(new CustomEvent("tgb:analytics-event",{detail:{name:name,parameters:Object.assign({},payload)}}))}function markStarted(){started||!root||!ready||(started=!0,sendEvent("tgb_builder_started",builderContext()))}function visibleStep(){if(root){var panel=root.querySelector("[data-step-panel]:not([hidden])");if(panel){var number=Number(panel.dataset.stepPanel||0);!number||viewedSteps[number]||(viewedSteps[number]=!0,sendEvent("tgb_builder_step_viewed",Object.assign(builderContext(),{step_number:number,step_name:STEP_NAMES[number]||"unknown"})))}}}function markReady(){if(!(ready||!root||!root.classList.contains("is-catalog-ready"))){ready=!0,enteredAt=Date.now(),sendEvent("tgb_builder_ready",Object.assign(builderContext(),{ready_elapsed_ms:loadedAt?Math.max(0,Date.now()-loadedAt):void 0})),sendEvent("tgb_builder_entered",builderContext()),visibleStep(),root.addEventListener("input",markStarted,{capture:!0}),root.addEventListener("change",markStarted,{capture:!0}),root.addEventListener("click",function(event){event.target.closest("[data-builder-exit]")||markStarted()},{capture:!0});var stepObserver=new MutationObserver(visibleStep);root.querySelectorAll("[data-step-panel]").forEach(function(panel){stepObserver.observe(panel,{attributes:!0,attributeFilter:["hidden"]})})}}function installBuilderTracking(){if(root=document.querySelector("[data-tgb-cyo-builder]"),!(!root||root.dataset.analyticsInitialized==="true")&&(root.dataset.analyticsInitialized="true",loadedAt=Date.now(),storedEntryLocation()||storeEntryContext(classifyEntryLocation(null,root.dataset.builderMode),root.dataset.builderMode||"unknown"),sendEvent("tgb_builder_loaded",builderContext()),markReady(),!ready)){var readyObserver=new MutationObserver(function(){markReady(),ready&&readyObserver.disconnect()});readyObserver.observe(root,{attributes:!0,attributeFilter:["class"]}),window.setTimeout(function(){ready||sendEvent("tgb_builder_catalog_timeout",Object.assign(builderContext(),{error_stage:"catalog_ready_timeout",elapsed_seconds:loadedAt?Math.max(0,Math.round((Date.now()-loadedAt)/1e3)):void 0}))},15e3)}}document.addEventListener("click",function(event){var curated=event.target.closest("[data-tgb-curated-gateway-link]"),cyo=event.target.closest("[data-tgb-cyo-launcher-link]"),link=event.target.closest("a[href]");if(!curated&&!cyo&&isCyoDestination(link)&&(cyo=link),!(!curated&&!cyo)){var mode=curated?"curated":"cyo",entryLocation=classifyEntryLocation(curated||cyo,mode);storeEntryContext(entryLocation,mode),sendEvent("tgb_builder_cta_clicked",builderContext(mode,curated?"curated_product":"cyo_product",entryLocation))}},!0),window.addEventListener("tgb:builder-step-completed",function(event){var detail=event.detail||{},number=Number(detail.stepNumber||0);!number||completedSteps[number]||(completedSteps[number]=!0,sendEvent("tgb_builder_step_completed",Object.assign(builderContext(detail.builderMode),{step_number:number,step_name:STEP_NAMES[number]||"unknown"})))}),window.addEventListener("tgb:builder-completed",function(event){var detail=event.detail||{},elapsedSeconds=enteredAt?Math.max(0,Math.round((Date.now()-enteredAt)/1e3)):void 0;sendEvent("tgb_builder_completed",Object.assign(builderContext(detail.builderMode),{item_count:Number(detail.itemCount||0)||void 0,elapsed_seconds:elapsedSeconds}))}),window.addEventListener("tgb:builder-error",function(event){var detail=event.detail||{};sendEvent("tgb_builder_error",Object.assign(builderContext(detail.builderMode),{error_stage:detail.errorStage||"unknown"}))}),document.readyState==="loading"?document.addEventListener("DOMContentLoaded",installBuilderTracking,{once:!0}):installBuilderTracking()})();
//# sourceMappingURL=/cdn/shop/t/189/assets/tgb-builder-events.js.map?v=4621961981755939031788278702







